import React, { useEffect, useState, useRef } from "react";
// BCM-891: "View my access" opens the user management page, as the spec says.
import { useHistory } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  Paper,
  CircularProgress,
  IconButton,
  Dialog,
  Typography,
  Grid,
  Box,
  TextField,
  Button,
  DialogContent,
  Checkbox,
  Link,
  Backdrop,
  // DialogActions,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import jwt_decode from "jwt-decode";

import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { downloadPdfFromBase64 } from "./pdfDownloadUtils";
// import EditRmPmLotMfgStartDate from "../POColumns/EditRmPmLotMfgStartDate";
// import EditRmPmLotMfgDispatchDate from "../POColumns/EditRmPmLotMfgDispatchDate";
// import EditRmPmLotMfgReceiptDate from "../POColumns/EditRmPmLotMfgReceiptDate";
import EditPlannedAllocatedQuantityDialog from "../POColumns/EditPlannedAllocatedQuantityDialog";
import DeleteLotAllocationDialog from "../POColumns/DeleteLotAllocationDialog";
import BatchAllocationElectronicSignature from "./BatchAllocationElectronicSignature";

import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import FlagIcon from "@material-ui/icons/Flag";
import StyledButton from "../../models/Button";
// import { ChevronRight } from "@material-ui/icons";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import StyledDialog from "../../../../../common/models/Dialog";
import jwtDecode from "jwt-decode";
import ViewRmPmLotTable from "./ViewRmPmLotTable";
import InfoTooltip from "../../models/InfoTooltip";
import {
  resolveLockReason,
  LOCK_REASONS,
  REASON_REQUEST_TYPE,
  REASON_ACTION_LABEL,
  reasonHasViewMyAccess,
  buildLockMessage,
  formatWindowDate,
  formatWindowCloseMoment,
} from "./allocationLockReason";
import VersionHistoryDialog from "./VersionHistoryDialog";
import QuickView from "../../sasl/common/drawer/QuickView";

const formatNetAvailableQty = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const numericValue = Number(value);
  return isNaN(numericValue) ? value : numericValue.toFixed(3);
};

// The backend stores a cleared value as the literal string "none" (for
// plannedLotNumbers and incomingExpectedDateOfArrivalAtCMO) rather than null/"".
// Normalize that back to "" wherever these fields are read for display or
// used to seed an edit field / decide whether a value already exists.
const normalizeClearedValue = (value) => (value && value !== "none" ? value : "");

const useStyles = makeStyles({
  tableContainer: {
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "auto",
    maxWidth: "100%",
    // `width: 0` + `min-width: 100%` forces this container to size
    // itself to the AVAILABLE space of its parent rather than to the wide
    // table's content. Without it, a flex/auto-sized ancestor lets this box
    // grow to fit the (now wider, 14-column) table, so its own overflow-x
    // never triggers and the page/tab panel ends up owning the horizontal
    // scroll instead — which also drags the Note text below the table along
    // with it. This keeps the scrollbar (and the sticky columns, which stick
    // relative to whichever ancestor actually scrolls) scoped to the table.
    width: 0,
    minWidth: "100%",
  },
  headerCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    minWidth: "90px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  editIconButton: {
    "&.Mui-disabled": {
      "& svg": {
        color: "#ec6535 !important",
        opacity: 0.4,
      },
    },
  },
  blackBorderFieldset: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
  },
  // Greyed, non-clickable Deplete Instruction indicator.
  customCheckbox: {
    opacity: 0.6,
  },
  // Keep the material-identification columns (BMS Material Code /
  // Description, Material BoM Qty., UoM) fixed in view while the rest of the
  // table scrolls horizontally. Offsets are fixed px, matching the minWidth
  // set on each of these columns (170 / 90 / 90) — position: sticky applies
  // `left` as an offset from the element's normal position at ALL times (not
  // only once "stuck"), so a percentage here resolves against the nearest
  // positioned ancestor's width, not the table's, and shifts the column even
  // at rest. Pixel offsets matching the actual column widths avoid that.
  stickyCol1: {
    position: "sticky",
    left: 0,
    zIndex: 2,
    backgroundColor: "#fff",
  },
  stickyCol2: {
    position: "sticky",
    left: 202,
    zIndex: 2,
    backgroundColor: "#fff",
  },
  stickyCol3: {
    position: "sticky",
    left: 323,
    zIndex: 2,
    backgroundColor: "#fff",
  },
  stickyHeaderCol1: {
    position: "sticky",
    left: 0,
    zIndex: 3,
  },
  stickyHeaderCol2: {
    position: "sticky",
    left: 202,
    zIndex: 3,
  },
  stickyHeaderCol3: {
    position: "sticky",
    left: 323,
    zIndex: 3,
  },
});

/*
 * BCM-891 tooltip bodies. Wording follows the spec table; only the reasons that
 * can be established in the browser are covered (see allocationLockReason.js).
 */
const ACCESS_ROWS = [
  ["cmo", "CMO"],
  ["plant", "Plant"],
  ["brand", "Brand"],
  ["productType", "Product type"],
];

// Each access of the PO with its value, "CMO · Patheon TRO", as the spec's mock-ups show it.
const renderAccessChecklist = (checklist, values = {}) => (
  <Box style={{ display: "flex", flexDirection: "column", gap: 2, margin: "8px 0" }}>
    {ACCESS_ROWS.map(([key, label]) => {
      const state = checklist?.[key];
      /*
       * The spec's two states are available and missing, and all four rows are
       * always listed. A dash is kept for the one case neither covers — the
       * associations could not be read at all — because a cross there would
       * accuse the user of lacking access nobody checked.
       */
      const missing = state === "missing";
      const mark = state === "available" ? "✓" : missing ? "✕" : "–";
      const markColor =
        state === "available" ? "#81c784" : missing ? "#e57373" : "#9e9e9e";
      const value = values[key];
      return (
        <Typography
          key={key}
          variant="body2"
          style={{ color: missing ? "#fff" : "#e0e0e0", fontSize: 17, fontWeight: missing ? 500 : 400 }}
        >
          <span style={{ color: markColor }}>{mark}</span> {label}
          {value ? ` · ${value}` : ""}
          {missing && (
            <span
              style={{
                marginLeft: 8,
                padding: "0 6px",
                border: "1px solid #ffb74d",
                borderRadius: 3,
                color: "#ffb74d",
                fontSize: 13,
              }}
            >
              Missing
            </span>
          )}
        </Typography>
      );
    })}
  </Box>
);

// The allocation-window tooltip (spec reason 4). Every value quoted here comes
// from the product's own configuration as returned by the middleware.
/*
 * BCM-891 tooltip body. The heading and message come from buildLockMessage so
 * the wording can be asserted against the spec table directly; this only lays
 * them out, plus the access checklist or document list the spec asks for.
 */
const renderAllocationLockContent = (lock, ctx) => {
  const { heading, message } = buildLockMessage(lock, ctx);
  const showChecklist =
    lock.reason === LOCK_REASONS.BRAND_MISSING ||
    lock.reason === LOCK_REASONS.MULTIPLE_MISSING ||
    // A single non-brand gap is an access problem like the other two, and the
    // spec shows the checklist for every access reason.
    lock.reason === LOCK_REASONS.ASSOCIATION_MISSING;
  const docs =
    lock.reason === LOCK_REASONS.DOCUMENTS_RECEIVED ? lock.documents || [] : [];

  return (
    <>
      {/* 500 is a weight index.html actually loads for Roboto; 600 and above
          are synthesised by the browser and render unevenly beside the rest of
          the product. Size carries the emphasis instead. */}
      <Typography variant="subtitle2" style={{ fontWeight: 500, color: "#fff", fontSize: 20 }}>
        {heading}
      </Typography>
      <Typography variant="body2" style={{ color: "#e0e0e0", marginTop: 8, fontSize: 17 }}>
        {message}
      </Typography>
      {showChecklist &&
        renderAccessChecklist(lock.checklist, {
          cmo: ctx.cmoName,
          plant: ctx.plant,
          brand: ctx.brand,
          productType: ctx.productType,
        })}
      {docs.length > 0 && (
        <Box style={{ display: "flex", flexDirection: "column", gap: 2, margin: "8px 0" }}>
          {docs.slice(0, 6).map((d, i) => (
            <Typography
              key={`${d.documentType}-${i}`}
              variant="body2"
              style={{ color: "#bdbdbd", fontSize: 17 }}
            >
              {/* Names only. The FSD's details for this reason are a "List of
                  batch documents received", and the one ingestion time belongs
                  in the sentence above — repeating it against every document
                  just restated the same timestamp on each line. */}
              {"•"} {d.documentType || "Document"}
            </Typography>
          ))}
          {docs.length > 6 && (
            <Typography variant="body2" style={{ color: "#9e9e9e", fontSize: 17 }}>
              and {docs.length - 6} more
            </Typography>
          )}
        </Box>
      )}
    </>
  );
};

// includeDeleted: the Delivered/Deleted POs dashboard, whose schedule line may be marked for delete.
// poMarkedForDelete: that dashboard's row says the PO is deleted, so no PDF can be generated for it.
const LotAllocationTable = ({ data, featuresAccess, showPencilIcon, preFetchedData = null, includeDeleted = false, poMarkedForDelete = false }) => {
  const classes = useStyles();
  const tokenData = jwtDecode(localStorage.getItem("authToken"));
  const [lotAllocationData, setLotAllocationData] = useState([]);
  const [lotAllocationRes, setLotAllocationRes] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  // Full-page loader between a successful allocation save and the Generate PDF
  // popup, so the user cannot act on the page while it refreshes.
  const [pdfFlowPageLoading, setPdfFlowPageLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedLotData, setSelectedLotData] = useState(null);
  const [rmPmCode, setrmPmCode] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  // const [selectedPoDetails, setSelectedPoDetails] = useState(null);

  const [saveFailed, setSaveFailed] = useState(false);
  const [editSuccessDialogOpen, setEditSuccessDialogOpen] = useState(false);
  const [editSuccessMessage, setEditSuccessMessage] = useState("");
  const [showPdfGenerationFlow, setShowPdfGenerationFlow] = useState(true);
  const [deleteSuccessDialogOpen, setDeleteSuccessDialogOpen] = useState(false);
  const [documentId, setDocumentId] = useState("");
  const [bomCode, setBomCode] = useState("");
  const [artworkCode, setArtworkCode] = useState("");
  /*
   * BCM-891: more than one artwork code can be captured. One textbox by default
   * with a plus beside it; each added textbox gets a delete, and the first never
   * does because at least one code is mandatory when artworkRequired is Yes.
   * Held alongside the single-value artworkCode so the pre-configuration popup
   * is untouched.
   */
  const [artworkCodes, setArtworkCodes] = useState([""]);
  const [includeDocumentIdRaw, setIncludeDocumentId] = useState(true);
  const [includeBomCodeRaw, setIncludeBomCode] = useState(true);
  const [includeArtworkCodeRaw, setIncludeArtworkCode] = useState(true);
  const [pdfFieldValidationError, setPdfFieldValidationError] = useState("");
  const [shareSuccessDialogOpen, setShareSuccessDialogOpen] = useState(false);
  const [pdfGenerationDialogOpen, setPdfGenerationDialogOpen] = useState(false);
  const [workflowDialogOpen, setWorkflowDialogOpen] = useState(false);
  const [sharingWithoutApproval, setSharingWithoutApproval] = useState(false);
  const [savingWorkflow, setSavingWorkflow] = useState(false);
  const [workflowValidationError, setWorkflowValidationError] = useState("");
  const [isProcessingApproval, setIsProcessingApproval] = useState(false);
  const [approvers, setApprovers] = useState([
    { id: 1, requirement: "Approval", approverOrg: "Internal", assignedMember: "", signature: "Electronic", changeOrder: "" }
  ]);
  const nextApproverID = useRef(2);

  // Team members data from API
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersData, setTeamMembersData] = useState([]); // Store raw user data for email mapping
  
  // Electronic signature and approval state
  const [electronicSignatureDialog, setElectronicSignatureDialog] = useState({
    open: false,
    decision: "", // "Approve" or "Reject"
  });
  const [approveRejectSuccess, setApproveRejectSuccess] = useState({
    open: false,
    type: "",
  });
  
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [plannedBatchDialog, setPlannedBatchDialog] = useState({
    open: false,
    rowData: null,
    componentData: null,
  });
  const [plannedQtyDialog, setPlannedQtyDialog] = useState({
    open: false,
    componentData: null,
  });
  const [editingBatchRow, setEditingBatchRow] = useState(null);
  const [plannedBatchNumber, setPlannedBatchNumber] = useState("");
  const [editingCountryRow, setEditingCountryRow] = useState(null);
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [editingArrivalDateRow, setEditingArrivalDateRow] = useState(null);
  const [expectedArrivalDate, setExpectedArrivalDate] = useState("");
  const [overAllocatedComponents, setOverAllocatedComponents] = useState([]);
  const [underAllocatedComponents, setUnderAllocatedComponents] = useState([]);
  const [batchAllocationPDFNotificationReqd, setBatchAllocationPDFNotificationReqd] = useState(false);
  const [excelUploadFile, setExcelUploadFile] = useState(null);

  // Validation function for planned batch number (all characters allowed, converted to uppercase)
  const handlePlannedBatchNumberChange = (e) => {
    const value = e.target.value;
    setPlannedBatchNumber(value.toUpperCase());
  };

  // Function to format batch numbers on blur (when user leaves the input)
  const handlePlannedBatchNumberBlur = () => {
    if (!plannedBatchNumber.trim()) return;

    // Clean up: remove empty values, trim spaces, add consistent spacing
    const cleaned = plannedBatchNumber
      .split(",")
      .map((batch) => batch.trim())
      .filter((batch) => batch.length > 0)
      .join(", ");

    setPlannedBatchNumber(cleaned);
  };

  // Delete dialog state
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedLotForDelete, setSelectedLotForDelete] = useState(null);
  const [selectedComponentForDelete, setSelectedComponentForDelete] =
    useState(null);

  const { organizationName, authToken } = localStorage;
  var token = authToken;
  var decoded = jwt_decode(token);

  const scheduleLineStatusID = data.scheduleLineDetails.scheduleLineStatusID;
  const batchStatusID = data.batchDetails.batchStatusID;
  const showPencilButton =
    showPencilIcon &&
    (scheduleLineStatusID === 25 ||
      scheduleLineStatusID === 29 ||
      scheduleLineStatusID === 31) &&
    (batchStatusID === null ||
      batchStatusID === 1 ||
      batchStatusID === undefined);

  // Common condition for edit icon visibility
  const canEditFields = ((localStorage.collabType === "CMO" && data?.scheduleLineDetails?.editPlannedAllocation && featuresAccess?.editPlannedAllocatedQty) ||
    (localStorage.collabType !== "CMO" && showPencilIcon && data?.scheduleLineDetails?.editPlannedAllocation && featuresAccess?.editPlannedAllocatedQty));

  /*
   * BCM-891: explain the greyed-out Planned Allocated Qty. edit button.
   * The caller's own CMO / brand / product-type associations are needed to tell
   * an access gap from the other reasons; saas_user_id comes off the decoded
   * authToken, the same way AllocatePOsModal obtains it.
   */
  // BCM-891: version history popup.
  const [versionHistoryOpen, setVersionHistoryOpen] = useState(false);

  /*
   * The version number has to reach both views. Pre-CMO QC Release reads
   * fetchComponentAllocationForPOLineNew and stores the whole response in
   * lotAllocationRes; Post-CMO QC Release reads
   * fetchComponentAllocationPlannedAndActualNew, whose branch sets only
   * lotAllocationData -- so lotAllocationRes stays empty there and anything
   * hanging off it would never appear after consumption. Both endpoints return
   * versionNumber, so it is kept in its own state that each branch sets.
   */
  const [allocationVersionNumber, setAllocationVersionNumber] = useState(undefined);

  /*
   * BCM-891: the PDF generation popup is driven by the CMO's per-product-type
   * configuration instead of the user ticking boxes.
   *
   *   documentIDReqd / artworkRequired  -> which fields the popup asks for
   *   allocationApprovalReqd            -> share directly, or route for approval
   *
   * The API doc has fetchComponentAllocationForPOLineNew returning these, but the
   * guard stays: against a build that does not send them pdfConfigured is false
   * and the popup behaves exactly as it does today -- the checkbox group, the BoM
   * Code field and both Share buttons all stay. Once the flags arrive the popup
   * follows the spec.
   */
  /*
   * True only when this CMO actually has a configuration for the PO's product
   * type.
   *
   * The middleware answers false for all three flags in two quite different
   * situations: the admin set them all to No, and no VendorProductTypeConfig
   * row exists at all. Those must not be treated alike — all-No means generate
   * the PDF with no popup, while an unconfigured product type has to keep the
   * pre-BCM-891 popup, with its checkbox group and both buttons, because the
   * spec says nothing about it and silently sharing a PDF would be worse.
   *
   * allocationPdfConfigFound settles it. A middleware that does not send it
   * falls back to the original test, so nothing changes on such a build.
   */
  // Replaced below — kept for reference. This told an unconfigured product type
  // apart from one configured to all-No, and showed the pre-BCM-891 popup for
  // the first. In practice that is the same popup users were asked to stop
  // seeing: the three columns are nullable, a never-saved row is NULL rather
  // than false, and the configuration screen already renders NULL as "No". So
  // the screen said No/No/No while this line still chose the old popup.
  // const pdfConfigured =
  //   lotAllocationRes?.allocationPdfConfigFound === true ||
  //   (lotAllocationRes?.allocationPdfConfigFound === undefined &&
  //     (lotAllocationRes?.documentIDReqd !== undefined ||
  //       lotAllocationRes?.artworkRequired !== undefined ||
  //       lotAllocationRes?.allocationApprovalReqd !== undefined));

  /*
   * The CMO configuration is in force as soon as the middleware is one that
   * knows about it, whatever it answers.
   *
   * allocationPdfConfigFound is set on every response by a BCM-891 middleware —
   * true or false, but never absent — so its mere presence identifies such a
   * build. The three flags are read the same way for the same reason.
   *
   * NULL is now treated as No rather than as "no configuration", which is what
   * the configuration screen has always displayed, so the popup and that screen
   * finally agree. All three No means no popup at all; only the fields set to
   * Yes are asked for.
   *
   * The guard that remains is the one that still means something: a middleware
   * from before BCM-891 sends none of these fields, cannot be asked what the
   * product type is configured as, and keeps the old popup.
   */
  const pdfConfigured =
    lotAllocationRes?.allocationPdfConfigFound !== undefined ||
    lotAllocationRes?.documentIDReqd !== undefined ||
    lotAllocationRes?.artworkRequired !== undefined ||
    lotAllocationRes?.allocationApprovalReqd !== undefined;
  const cfgDocumentIdReqd = lotAllocationRes?.documentIDReqd === true;
  const cfgArtworkReqd = lotAllocationRes?.artworkRequired === true;
  const cfgApprovalReqd = lotAllocationRes?.allocationApprovalReqd === true;

  /*
   * BCM-891: the four CMO-configuration values, forwarded back to the middleware
   * on /updateComponentAllocationNew and /generateBatchAllocationPDF. The API doc
   * asks for this because processBatchAllocationWithoutApproval is invoked
   * internally when Approval = No and has no DB access to read the config itself,
   * so the FE — which already holds it from /fetchComponentAllocationForPOLineNew
   * — has to pass it through.
   *
   * Spread as an empty object while pdfConfigured is false: a middleware that
   * does not return the config must not be told documentIDReqd is false, and the
   * payloads then go out byte-for-byte as they do today.
   */
  const cmoPdfConfig = pdfConfigured
    ? {
        documentIDReqd: cfgDocumentIdReqd,
        artworkRequired: cfgArtworkReqd,
        allocationApprovalReqd: cfgApprovalReqd,
        allocationPDFTitle: lotAllocationRes?.allocationPDFTitle ?? "",
      }
    : {};

  /*
   * Which fields the popup actually requires. Once the CMO configuration is
   * available it decides, and the checkboxes are gone; before that the user's
   * own ticks still apply, so nothing changes on a middleware without the flags.
   * BoM Code is never required under the configuration -- the spec removes it.
   */
  const includeDocumentId = pdfConfigured ? cfgDocumentIdReqd : includeDocumentIdRaw;
  const includeArtworkCode = pdfConfigured ? cfgArtworkReqd : includeArtworkCodeRaw;
  const includeBomCode = pdfConfigured ? false : includeBomCodeRaw;

  // Comma-separated, in entry order, blanks dropped — the shape
  // /updateApprovalWorkflow documents for multipleArtworkCodes.
  const multipleArtworkCodes = artworkCodes
    .map((c) => String(c || "").trim())
    .filter(Boolean)
    .join(",");

  /*
   * Every displayed textbox is mandatory and duplicates are not allowed, so the
   * message names which rule failed rather than just refusing. Returns "" when
   * the codes are acceptable, or when artwork is not being captured at all.
   */
  const artworkCodesError = () => {
    if (!pdfConfigured || !includeArtworkCode) return "";
    const trimmed = artworkCodes.map((c) => String(c || "").trim());
    if (trimmed.some((c) => c === "")) return "Please enter a value in every Artwork Code field";
    const seen = new Set();
    for (const c of trimmed) {
      const key = c.toLowerCase();
      if (seen.has(key)) return `Artwork Code '${c}' is entered more than once`;
      seen.add(key);
    }
    return "";
  };

  const addArtworkCode = () => setArtworkCodes((prev) => [...prev, ""]);
  const removeArtworkCode = (index) =>
    setArtworkCodes((prev) => prev.filter((_, i) => i !== index));
  const setArtworkCodeAt = (index, value) =>
    setArtworkCodes((prev) => prev.map((c, i) => (i === index ? value : c)));

  const [userAssociations, setUserAssociations] = useState({});
  useEffect(() => {
    const saasUserID = tokenData?.saas_user_id;
    if (!saasUserID) return undefined;
    let cancelled = false;
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchUserAssociationsDirect/${saasUserID}`
      )
      .then((res) => {
        // fetchUserAssociationsDirect answers with an envelope —
        // { status, message, data: { associatedBrandList, ... } } — so the lists
        // sit one level below the axios body. Reading res.data alone left every
        // list undefined, which made computeAccessChecklist report 'unknown' for
        // all three and suppressed the brand / multiple-access tooltips entirely.
        if (!cancelled) setUserAssociations(res?.data?.data || res?.data || {});
      })
      .catch(() => {
        // Non-fatal: resolveLockReason reports 'unknown' rather than claiming
        // an access gap, so a failed call shows no tooltip instead of a wrong one.
      });
    return () => {
      cancelled = true;
    };
  }, [tokenData?.saas_user_id]);

  /*
   * BCM-891: download the PDF for one historical version. Built to the
   * documented /generateBatchAllocationPDF contract — the same endpoint as the
   * current-version PDF, with versionNumber added; omitting it means "current".
   * A failure is surfaced to the user rather than failing silently, so a build
   * without the parameter reports an error instead of handing back the wrong PDF.
   */
  /*
   * The users associated with the product, as the PDF popup loads them for CC.
   * Loaded here as well when the popup has not been opened, so a version PDF
   * never goes out with an empty CC or unresolved names.
   */
  const loadAssociatedUsers = async () => {
    if (teamMembersData?.length) return teamMembersData;
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAssociatedUsers`;
      const res = await axios.post(url, { productCode: lotAllocationRes?.boProductCode });
      if (res.data?.status && Array.isArray(res.data.data)) {
        setTeamMembersData(res.data.data);
        return res.data.data;
      }
    } catch (err) {
      console.error("Error fetching associated users:", err);
    }
    return [];
  };

  const handleDownloadVersionPdf = async (version, materialIndex) => {
    const versionNumber = version?.versionNumber ?? version;
    try {
      const users = await loadAssociatedUsers();
      const byEmail = new Map(
        users.filter((u) => u?.emailAddress).map((u) => [u.emailAddress.toLowerCase(), u])
      );
      // Same resolution as the PDF sent after approval: full name, then "Role, Department".
      const person = (email) => {
        const u = byEmail.get(String(email || "").toLowerCase());
        if (!u) return { name: email || "", role: "", department: "" };
        return { name: u.fullName || email, role: u.roleName || "", department: u.departmentName || "" };
      };
      const reviewedAndApprovedBy = (version?.approvalWorkflowDetails || [])
        .filter((a) => (a?.decision === "Approved" || a?.decision === "Approve") && a?.decisionBy)
        .map((a) => {
          const who = person(a.decisionBy);
          return {
            name: who.name,
            role: who.role && who.department ? `${who.role}, ${who.department}` : who.role,
            date: a.decisionDate,
          };
        });
      const creator = person(version?.lastUpdatedBy);
      const components = version?.componentAllocationDataList || [];
      // The spec gives each material of a version its own PDF.
      const componentsForPdf =
        Number.isInteger(materialIndex) && components.length > 1
          ? [components[materialIndex]].filter(Boolean)
          : components;
      // What was recorded against this version; a middleware that does not send it yet falls back to the current PO.
      const fromVersion = (key, current) =>
        version && Object.prototype.hasOwnProperty.call(version, key) ? version[key] : current;

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/generateBatchAllocationPDF`;
      const res = await axios.post(url, {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        // Mandatory — the endpoint answers 400 without it.
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
        versionNumber,
        poNumber: lockPo.poNumber,
        fgMaterialCode: lotAllocationRes?.boProductCode || lotAllocationRes?.productCode,
        fgMaterialName: lotAllocationRes?.boProductDescription,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        brand: lockPo.brand,
        productType: lockPo.productType,
        /*
         * BCM-891: generateBatchAllocationPDF destructures `documentId` with a
         * lower-case d. This was sending `documentID`, so the value was dropped
         * and the Document ID never printed on a version-history PDF even with
         * Document ID Required = Yes.
         */
        documentId: fromVersion("documentID", lotAllocationRes?.documentID),
        /*
         * The controller splits this on commas and prints one bullet per code,
         * so it wants the whole list. artworkCode holds only the first.
         */
        artworkCode:
          fromVersion("multipleArtworkCodes", lotAllocationRes?.multipleArtworkCodes) ||
          fromVersion("artworkCode", lotAllocationRes?.artworkCode),
        /*
         * The Subject and Objective text, and the product description used in
         * their {Product Description} substitution. Unlike the share paths,
         * which run through processBatchAllocationWithoutApproval and let it
         * resolve these, this call reaches the PDF controller directly — so
         * nothing else supplies them and the PDF fell back to the hard-coded
         * "Component Allocation Notification", an empty Objective and "N/A".
         */
        productDescription: lotAllocationRes?.boProductDescription,
        subject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        objective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        cc: users.map((user) => user.fullName),
        plantID: data?.scheduleLineDetails?.vendorPlant,
        storageLocationID: data?.scheduleLineDetails?.storageLocation,
        /*
         * Taken from the version itself rather than the signed-in user, so a
         * historical PDF names who actually made that version and when.
         */
        createdBy: creator.name,
        createdByRole: creator.role,
        departmentName: creator.department,
        allocationDate: version?.createdAt,
        // Printed only when the product type requires approval; this version's own approvers.
        reviewedAndApprovedBy,
        // generateBatchAllocationPDF only PRINTS versionNumber — it does not look
        // the version up. The rows it renders are the ones sent here, so this
        // version's own allocation data has to be supplied, not the current one.
        componentAllocationDataList: componentsForPdf,
        // BCM-891: CMO configuration forwarded per the API doc — see cmoPdfConfig.
        ...cmoPdfConfig,
      });
      const base64 = res?.data?.pdfBase64;
      if (!base64) {
        console.error("[BCM-891] version PDF: no pdfBase64 in response", res?.data);
        alert(`The PDF for this version could not be generated.${res?.data?.errorMessage ? `\n${res.data.errorMessage}` : ""}`);
        return;
      }
      // base64 -> Blob without fetch(), so no data: URI length limit applies.
      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
      const href = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = href;
      const materialCode =
        components.length > 1 ? componentsForPdf[0]?.componentAllocationDetails?.componentCode : "";
      a.download = `Batch_Allocation_v${versionNumber}${materialCode ? `_${materialCode}` : ""}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // Released later: this runs after awaits, and revoking at once can cancel the download.
      setTimeout(() => URL.revokeObjectURL(href), 10000);
    } catch (err) {
      console.error("[BCM-891] version PDF download failed", err);
      const detail = err?.response?.data?.errorMessage || err?.message;
      alert(`The PDF for this version could not be generated.${detail ? `\n${detail}` : ""}`);
    }
  };

  /*
   * BCM-891: the PO facts the access checklist compares against.
   * fetchComponentAllocationForPOLineNew is the source — the PO list's
   * scheduleLineDetails carries neither brand nor productTypeID, so matching
   * against it left both 'unknown' and no access tooltip could ever resolve.
   * scheduleLineDetails is still read for the PO number and the CMO org ID.
   */
  const lockPo = {
    poNumber:
      lotAllocationRes?.poNumber || data?.scheduleLineDetails?.scheduleAgreementNumber,
    brand: lotAllocationRes?.brand ?? data?.scheduleLineDetails?.brand,
    productTypeID: lotAllocationRes?.productTypeID,
    productType: lotAllocationRes?.productType,
    vendorMosymphonyID:
      lotAllocationRes?.vendorMosymphonyID ?? data?.scheduleLineDetails?.vendorMosymphonyID,
  };

  const allocationLock = resolveLockReason({
    canEditFields,
    hasRoleEditAccess: featuresAccess?.editPlannedAllocatedQty === true,
    po: lockPo,
    associations: userAssociations,
    allocationWindow: lotAllocationRes?.allocationWindow || null,
    // Read off the decoded token rather than the collaboratorTypeID const —
    // that one is declared further down the component and would be in its
    // temporal dead zone here. Same claim, same value.
    //
    // Falls back to collabType, which the rest of this component already trusts
    // for exactly this distinction (see canEditFields). Without it, a token
    // missing the claim made the allocation-window reason disappear silently,
    // because no side of the window could be selected.
    collaboratorTypeID:
      tokenData?.collaborator_type_id ??
      (localStorage.collabType === "CMO" ? 2 : 1),
    batchDocuments: lotAllocationRes?.batchDocumentsReceived || [],
    batchNumber: data?.batchDetails?.vendorBatchNumber || null,
  });

  /*
   * The values the spec's tooltip sentences quote. roleName is decoded because
   * it is stored URL-encoded — "EXM%20SC%20Planner" would otherwise be shown to
   * the user verbatim.
   */
  const lockCtx = {
    roleName: decodeURIComponent(localStorage.getItem("roleName") || ""),
    poNumber: lockPo.poNumber,
    productCode: lotAllocationRes?.boProductCode || lotAllocationRes?.productCode,
    brand: lockPo.brand,
    // The spec quotes the CMO by name in two of the five messages. vendorName is
    // enriched from SML and is the usual source, but it comes back as '' when the
    // org name could not be resolved, so cmoName is tried first — the same pair
    // ApproveRejectConsumedBatch already reads. Both empty just drops the name
    // from the sentence rather than printing an empty quote.
    cmoName:
      data?.scheduleLineDetails?.cmoName || data?.scheduleLineDetails?.vendorName,
    productType: lockPo.productType,
    batchNumber: data?.batchDetails?.vendorBatchNumber,
    plant: data?.scheduleLineDetails?.vendorPlant,
  };

  /*
   * BCM-891 tooltip actions. Each raises an in-app notification to the BMS
   * admin through /requestBatchAllocationAccessDirect — no email is sent, and
   * nothing about the user's permissions or the product's configuration is
   * changed, so the button stays disabled until the admin actions it.
   *
   * The result is reported in a banner on the tab, carrying the reference
   * number the notification was raised under, as the spec describes.
   */
  const [accessRequest, setAccessRequest] = useState(null); // {severity, text}
  const [accessRequestBusy, setAccessRequestBusy] = useState(false);
  const [batchDocumentsOpen, setBatchDocumentsOpen] = useState(false);
  /*
   * BCM-891: "View my access".
   *
   * The spec says this "opens the user management page, where the user can view
   * the CMOs, plants, brands and product types they have access to". It used to
   * open a small dialog built here instead — a screen the spec does not
   * describe, listing only what this component happened to have loaded, and
   * unable to show plants at all. Removed in favour of the page the spec names.
   */
  const history = useHistory();
  const openMyAccess = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/` +
        `${localStorage.organizationName}/${localStorage.ecosystemId}/teamMembers`
    );
  };

  /*
   * BCM-891: what this user has already asked for on this PO.
   *
   * Once a request has gone to the admin the tooltip says so — the note is
   * shown in place of the action — and the same request cannot be raised again
   * for 48 hours. Without that, a user looking at a button that stays disabled
   * (as the FSD says it must, until an admin actions the request) can send the
   * same notification to every admin over and over.
   *
   * The middleware is what enforces the window; this only keeps the user from
   * clicking into a refusal, and carries the note. Fetched only when a lock
   * reason with an action is actually on screen, so an editable PO makes no
   * extra call.
   */
  const [accessRequestHistory, setAccessRequestHistory] = useState({});

  /*
   * Who the request actually went to. It goes to the admins of the requester's
   * own organisation, so a CMO user's goes to their CMO admin and saying "BMS
   * admin" would be wrong. The middleware sends the label it used; collabType
   * is the fallback, and gives the same answer because the label depends only
   * on who is logged in.
   */
  const adminLabelOf = (source) =>
    source?.adminLabel ||
    (localStorage.collabType === "CMO" ? "CMO admin" : "BMS admin");
  const lockRequestType = REASON_REQUEST_TYPE[allocationLock?.reason];
  const lockSchrockenSLID = data?.scheduleLineDetails?.schrockenSLID;

  useEffect(() => {
    if (!lockRequestType || !lockSchrockenSLID) return undefined;
    let cancelled = false;
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBatchAllocationAccessRequestStatusDirect`,
        {
          schrockenSLID: lockSchrockenSLID,
          requestedBySaasUserID: tokenData?.saas_user_id,
          requestedBy: tokenData?.email_address,
        }
      )
      .then((res) => {
        if (!cancelled && res?.data?.status) {
          setAccessRequestHistory(res?.data?.data?.requests || {});
        }
      })
      .catch(() => {
        // Non-fatal: the action is offered as before, and the middleware still
        // declines to raise a duplicate inside the window, so the worst case is
        // the user finding out on click instead of on hover.
      });
    return () => {
      cancelled = true;
    };
  }, [lockRequestType, lockSchrockenSLID, tokenData?.saas_user_id]);

  // The outstanding request for the reason currently on screen, and whether its
  // window is still open.
  const priorAccessRequest = lockRequestType
    ? accessRequestHistory[lockRequestType]
    : null;
  const accessRequestCooldownActive =
    !!priorAccessRequest?.nextRequestAllowedAt &&
    new Date(priorAccessRequest.nextRequestAllowedAt).getTime() > Date.now();

  // Remember what the server just told us, so the note appears without waiting
  // for another round trip.
  const rememberAccessRequest = (requestType, d, justSent = false) => {
    if (!requestType || !d) return;
    setAccessRequestHistory((prev) => ({
      ...prev,
      [requestType]: {
        requestType,
        // True only for a request raised in this session, so the tooltip can
        // confirm it rather than merely report it.
        justSent,
        referenceNumber: d.referenceNumber,
        requestedAt: d.requestedAt,
        requestedAtDisplay: d.requestedAtDisplay,
        nextRequestAllowedAt: d.nextRequestAllowedAt,
        nextRequestAllowedAtDisplay: d.nextRequestAllowedAtDisplay,
        cooldownHours: d.cooldownHours,
      },
    }));
  };

  const handleRaiseAccessRequest = async () => {
    const requestType = REASON_REQUEST_TYPE[allocationLock?.reason];
    if (!requestType || accessRequestBusy) return;
    // Already sent and still inside the window — nothing to send.
    if (accessRequestCooldownActive) return;
    setAccessRequestBusy(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/requestBatchAllocationAccessDirect`;
      const res = await axios.post(url, {
        requestType,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        poNumber: lockPo.poNumber,
        productCode: lotAllocationRes?.boProductCode || lotAllocationRes?.productCode,
        productDescription: lotAllocationRes?.boProductDescription,
        brand: lockPo.brand,
        productType: lockPo.productType,
        cmoName: data?.scheduleLineDetails?.vendorName,
        // productTypeID lets the middleware narrow the notification to the BMS
        // admins associated with this PO's CMO, brand and product type.
        productTypeID: lockPo.productTypeID,
        // The allocation-window facts the notification prints for a product
        // configuration request: Current PO Status, Delivery Date and
        // "Configured Allocation Window: <start status> to N days before delivery".
        currentPOStatus: allocationLock?.window?.currentPOStatusText || null,
        deliveryDate: allocationLock?.window
          ? formatWindowDate(allocationLock.window.deliveryDate)
          : null,
        startPOStatus: allocationLock?.window?.startPOStatusText || null,
        // Same request as a closed window; the notification says which.
        windowNotOpen: allocationLock?.reason === LOCK_REASONS.WINDOW_NOT_OPEN,
        daysBeforeDelivery: allocationLock?.window?.daysBeforeDelivery ?? null,
        windowCloseDate: allocationLock?.window
          ? formatWindowCloseMoment(allocationLock.window.windowCloseDate)
          : null,
        batchNumber: data?.batchDetails?.vendorBatchNumber,
        missingAccess: allocationLock?.missing || [],
        roleName: decodeURIComponent(localStorage.getItem("roleName") || ""),
        requestedBy: tokenData?.email_address,
        requestedByName: tokenData?.full_name || tokenData?.email_address,
        requestedBySaasUserID: tokenData?.saas_user_id,
        vendorMosymphonyID: lockPo.vendorMosymphonyID,
        brandOwnerMosymphonyID:
          lotAllocationRes?.brandOwnerMosymphonyID ??
          data?.scheduleLineDetails?.brandOwnerMosymphonyID,
      });
      if (res?.data?.status) {
        const d = res.data.data || {};
        // alreadyRequested means nothing new went out, so it is not "just sent".
        rememberAccessRequest(requestType, d, !d.alreadyRequested);

        /*
         * The same request was already raised for this PO and is still inside
         * the 48-hour window, so nothing new was sent. Said plainly, with the
         * reference of the request that IS outstanding, rather than letting the
         * user believe a second one went out.
         */
        if (d.alreadyRequested) {
          setAccessRequest({
            severity: "info",
            text:
              `${d.requestLabel || "This request"} has already been sent to the ${adminLabelOf(d)} ` +
              `on '${formatWindowDate(d.requestedAt, true) || d.requestedAtDisplay}', ` +
              `for your role '${lockCtx.roleName}' on ` +
              `${lockCtx.poNumber ? `PO '${lockCtx.poNumber}'` : "this PO"}. ` +
              `Reference '${d.referenceNumber}'. It has not been actioned yet, so it was not sent again — ` +
              `you can raise it once more after ` +
              `'${formatWindowDate(d.nextRequestAllowedAt, true) || d.nextRequestAllowedAtDisplay}'.`,
          });
        } else {
          const admins = (d.notifiedAdmins || []).join(", ");
          /*
            The spec asks the banner to state what was requested, who it went to,
            when, the reference, the role and the PO it was raised for, and that
            the user will be notified once it is actioned.

            Each substituted value is quoted, the way every message template in
            the FSD quotes them -- '<PO Number>', '<Ingestion Date and Time>' --
            so the banner reads as the same family of text as the tooltip and
            the notification rather than a looser paraphrase of them.
          */
          setAccessRequest({
            severity: "success",
            text:
              `${d.requestLabel || "Your request"} was sent to the ${adminLabelOf(d)}` +
              `${admins ? ` '${admins}'` : ""} ` +
              `on '${formatWindowDate(d.requestedAt, true)}', ` +
              `for your role '${lockCtx.roleName}' on ` +
              `${lockCtx.poNumber ? `PO '${lockCtx.poNumber}'` : "this PO"}. ` +
              `Reference '${d.referenceNumber}'. You'll be notified once it's actioned — ` +
              `editing stays disabled until then.`,
          });
        }
      } else {
        setAccessRequest({
          severity: "error",
          text: res?.data?.errorDescription || "The request could not be raised.",
        });
      }
    } catch (err) {
      setAccessRequest({
        severity: "error",
        text: "The request could not be raised. Please try again.",
      });
    } finally {
      setAccessRequestBusy(false);
    }
  };

  // The action row inside the tooltip. Rendered only for reasons the spec gives
  // an action for, which is every reason resolved here.
  const renderLockActions = () => {
    const requestType = REASON_REQUEST_TYPE[allocationLock?.reason];
    if (!requestType) return null;
    const label = REASON_ACTION_LABEL[allocationLock.reason];
    const canViewDocuments =
      allocationLock.reason === LOCK_REASONS.DOCUMENTS_RECEIVED &&
      !!data?.batchDetails?.schrockenDeliveryScheduleBatchID;
    return (
      <Box style={{ display: "flex", gap: 12, marginTop: 10, flexWrap: "wrap" }}>
        {/* BCM-891: the batch's documents, in the batch dashboard's own detail view. */}
        {canViewDocuments && (
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={() => setBatchDocumentsOpen(true)}
            style={{ color: "#ffb74d", fontWeight: 500, fontSize: 17 }}
          >
            View documents
          </Link>
        )}
        {/*
          BCM-891: once the request has gone to the admin the tooltip says
          so every time it is opened, with when it was sent and the reference it
          was raised under, so the user is not left wondering whether it landed.
          The action itself is withheld while the 48-hour window is open —
          re-sending would only add another identical notification, and the edit
          button stays disabled either way until an admin actions it.
        */}
        {priorAccessRequest && (
          <Typography
            variant="body2"
            style={{
              width: "100%",
              // Green the moment it is sent, amber on later visits: the first
              // is a confirmation, the second is a reminder.
              color: priorAccessRequest.justSent ? "#a5d6a7" : "#ffe082",
              fontWeight: 500,
              fontSize: 17,
              lineHeight: 1.5,
            }}
          >
            {`${priorAccessRequest.justSent ? "Sent" : "Already sent"} to the ${adminLabelOf(
              priorAccessRequest
            )} on '${
              formatWindowDate(priorAccessRequest.requestedAt, true) ||
              priorAccessRequest.requestedAtDisplay
            }'`}
            {priorAccessRequest.referenceNumber
              ? ` (reference '${priorAccessRequest.referenceNumber}')`
              : ""}
            {accessRequestCooldownActive
              ? `. You can send it again after '${
                  formatWindowDate(priorAccessRequest.nextRequestAllowedAt, true) ||
                  priorAccessRequest.nextRequestAllowedAtDisplay
                }'.`
              : `. Send it again if it still has not been actioned.`}
          </Typography>
        )}
        {/*
          The action, with a spinner while it is in flight. The tooltip is
          interactive, so it stays open under the cursor for the whole round
          trip — the user watches it send, then sees the note replace the link
          in place, without the tooltip closing under them.
        */}
        {!accessRequestCooldownActive && (
        <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {accessRequestBusy && (
            <CircularProgress size={15} thickness={5} style={{ color: "#ffb74d" }} />
          )}
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={handleRaiseAccessRequest}
            disabled={accessRequestBusy}
            style={{
              color: "#ffb74d",
              fontWeight: 500,
              fontSize: 17,
              // A disabled MUI Link keeps full contrast, which reads as still
              // clickable; dim it so "sending" looks like sending.
              opacity: accessRequestBusy ? 0.7 : 1,
            }}
          >
            {accessRequestBusy ? "Sending…" : label}
          </Link>
        </Box>
        )}
        {/*
          "View my access" is withdrawn pending confirmation from the product
          team. It was offered on the more-than-one-association reason, but a
          planner cannot open the user management page the spec sends them to —
          that screen is gated on manageTeamMembers — so the action led nowhere
          useful. reasonHasViewMyAccess and openMyAccess are both still here, so
          restoring it is one line if the product team wants it back.
        */}
      </Box>
    );
  };

  // Wraps a disabled edit button in the shared tooltip when the reason is known.
  // The button is rendered untouched when it is not — a disabled control with no
  // explanation is still better than a confident wrong one.
  // A delivered or deleted PO is never editable, so there is nothing to explain or request there.
  const withLockTooltip = (button) =>
    allocationLock && !includeDeleted ? (
      <InfoTooltip icon={button} closable>
        <>
          {renderAllocationLockContent(allocationLock, lockCtx)}
          {renderLockActions()}
        </>
      </InfoTooltip>
    ) : (
      button
    );

  // Helper function to check if all planned allocated quantities are NA
  const plannedComponents = () =>
    lotAllocationRes?.componentAllocationDataList || lotAllocationData;

  const areAllPlannedAllocatedQuantitiesNA = () => {
    const components = plannedComponents();
    if (!components || components.length === 0) return true;

    return components.every(component => {
      if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
        return component.lotNumberAllocationDetails.every(lot => 
          !lot?.plannedAllocatedQuantity || 
          lot?.plannedAllocatedQuantity === null || 
          lot?.plannedAllocatedQuantity === undefined ||
          lot?.plannedAllocatedQuantity === "NA"
        );
      }
      return true;
    });
  };
  
  const handleLotAllocationStatus = async (type, message = "Component Allocation updated successfully", showPdfFlow = true) => {
    if (type === "success") {
      // Fetch latest data before showing success dialog. When the Generate PDF
      // popup follows, block the page for the refresh so nothing else can be
      // clicked before it appears.
      const pdfPopupWillShow = showPdfFlow && batchAllocationPDFNotificationReqd;
      if (pdfPopupWillShow) setPdfFlowPageLoading(true);
      setTableLoading(true);
      try {
        await fetchLotAllocationData();
      } finally {
        setPdfFlowPageLoading(false);
      }
      setEditSuccessMessage(message);
      // Set whether to show PDF generation flow based on the parameter
      setShowPdfGenerationFlow(showPdfFlow);
      setEditSuccessDialogOpen(true);
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  const handleRefreshLotAllocation = () => {
    setTableLoading(true);
    fetchLotAllocationData();
  };

  // Fetch data with polling mechanism to ensure fresh data
  

  const fetchLotAllocationData = async () => {
    let url = "";
    if (
      data?.batchDetails &&
      data?.batchDetails?.bomConsumptionAddedIndicator
    ) {
      const batchSize = data?.batchDetails?.batchSize;
      const dsbID = data?.batchDetails?.schrockenDeliveryScheduleBatchID;
      if (!dsbID) {
        setTableLoading(false);
        return;
      }
      // BCM-891: carries includeDeleted for the same reason the two
      // fetchComponentAllocationForPOLineNewDirect calls below do -- on the
      // Delivered/Deleted POs dashboard the schedule line is soft-deleted, and
      // without it the API answers 200 with an empty list and the allocation
      // and consumption view comes up blank.
      url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNewDirect/${dsbID}/${batchSize}${includeDeleted ? "?includeDeleted=true" : ""}`;
    } else {
      const slID = data?.scheduleLineDetails?.schrockenSLID;
      if (!slID) {
        setTableLoading(false);
        return;
      }
      url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${slID}${includeDeleted ? "?includeDeleted=true" : ""}`;
    }

    try {
      const res = await axios.get(url);
      
      if (res.data.status) {
        if (
          data?.batchDetails &&
          data?.batchDetails?.bomConsumptionAddedIndicator
        ) {
          setAllocationVersionNumber(
            res.data.data?.versionNumber ?? res.data.versionNumber
          );
          if (res.data.data.length > 0) {
            setLotAllocationData(res.data.data);
            setLotAllocationRes(res.data)
          } else {
            setLotAllocationData([]);
            setLotAllocationRes({})
            setError(false);
          }
          // BCM-891: the Post-CMO QC Release view keeps the Generate PDF button and
          // PDF link, which run on the planned allocation this endpoint does not return.
          const plannedSLID = data?.scheduleLineDetails?.schrockenSLID;
          if (plannedSLID) {
            try {
              const planned = await axios.get(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${plannedSLID}${includeDeleted ? "?includeDeleted=true" : ""}`
              );
              if (planned.data?.status && planned.data?.data?.componentAllocationDataList) {
                setLotAllocationRes(planned.data.data);
                setBatchAllocationPDFNotificationReqd(planned.data.data.batchAllocationPDFNotificationReqd || false);
              }
            } catch {
              // The consumption table still renders; only the PDF controls stay hidden.
            }
          }
        } else {
          if (res.data.data.componentAllocationDataList.length > 0) {
            setLotAllocationData(res.data.data.componentAllocationDataList);
            setLotAllocationRes(res.data.data);
            setAllocationVersionNumber(res.data.data?.versionNumber);
            // Store the batchAllocationPDFNotificationReqd flag
            setBatchAllocationPDFNotificationReqd(res.data.data.batchAllocationPDFNotificationReqd || false);
          } else {
            setLotAllocationData([]);
            setLotAllocationRes([]);
            setBatchAllocationPDFNotificationReqd(false);
            setError(false);
          }
        }
      } else {
        setError(true); // If API response is not successful
      }
      // Fetch Excel upload files for this SL in the same load cycle
      const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
      if (schrockenSLID) {
        try {
          const filesRes = await axios.get(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFilesForSL/${schrockenSLID}`
          );
          if (filesRes.data?.status && filesRes.data?.data?.customFiles) {
            const excelFiles = filesRes.data.data.customFiles
              .filter(f => f.customFileType === "BatchAllocationExcel" && f.lastUpdatedDate)
              .sort((a, b) => new Date(b.lastUpdatedDate) - new Date(a.lastUpdatedDate));
            setExcelUploadFile(excelFiles.length > 0 ? excelFiles[0] : null);
          }
        } catch {
          // silently ignore — download link is optional
        }
      }
    } catch (err) {
      console.error("Error fetching lot allocation data:", err);
      setError(true);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    if (preFetchedData !== null) {
      setLotAllocationData(preFetchedData);
      setLotAllocationRes(Array.isArray(preFetchedData) ? { data: preFetchedData } : preFetchedData);
      setTableLoading(false);
      setError(false);
      return;
    }

    if (isProcessingApproval) return;

    setTableLoading(true);
    fetchLotAllocationData();
  }, [data, preFetchedData, isProcessingApproval]);

  // Fetch team members when PDF generation dialog opens (needed for both approval flows)
  useEffect(() => {
    const fetchTeamMembers = async () => {
      if (pdfGenerationDialogOpen) {
        try {
          const payload = {
            productCode: lotAllocationRes?.boProductCode
          };
          
          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAssociatedUsers`;
          
          const response = await axios.post(url, payload);
          
          
          // Format team members data for dropdown with email as value
          if (response.data.status && response.data.data) {
            const formattedMembers = response.data.data.map(user => ({
              label: `${user.fullName} (${user.departmentName} - ${user.roleName})`,
              email: user.emailAddress
            }));
            setTeamMembers(formattedMembers);
            // Keep raw data if needed for other purposes
            setTeamMembersData(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching associated users:", error);
        }
      }
    };
    
    fetchTeamMembers();
  }, [pdfGenerationDialogOpen, lotAllocationRes?.boProductCode]);

  // Check for over-allocated and under-allocated components
  useEffect(() => {
    if (lotAllocationData && lotAllocationData.length > 0) {
      const overAllocated = [];
      const underAllocated = [];

      lotAllocationData.forEach((component) => {
        const bomQty = component?.componentAllocationDetails?.componentQuantity;

        // Check if lotNumberAllocationDetails exists and has data
        const hasLotAllocationData =
          component?.lotNumberAllocationDetails &&
          component?.lotNumberAllocationDetails.length > 0;

        if (!hasLotAllocationData) {
          // Skip if no lot allocation data (would show as "NA")
          return;
        }

        const totalPlannedQty =
          component?.lotNumberAllocationDetails?.reduce((sum, lot) => {
            const plannedQty = lot?.plannedAllocatedQuantity;

            if (
              plannedQty === null ||
              plannedQty === undefined ||
              plannedQty === "NA"
            ) {
              return sum;
            }
            return sum + (parseFloat(plannedQty) || 0);
          }, 0) || 0;

        if (totalPlannedQty === 0) {
          return;
        }

        // Round both values to 3 decimals for consistent comparison
        const roundedTotal = Math.round(totalPlannedQty * 1000) / 1000;
        const roundedBomQty = Math.round(bomQty * 1000) / 1000;

        if (roundedTotal > roundedBomQty) {
          overAllocated.push(component);
        } else if (roundedTotal < roundedBomQty) {
          underAllocated.push(component);
        }
      });

      setOverAllocatedComponents(overAllocated);
      setUnderAllocatedComponents(underAllocated);
    } else {
      setOverAllocatedComponents([]);
      setUnderAllocatedComponents([]);
    }
  }, [lotAllocationData]);

  // Function to open planned qty edit dialog directly (confirmation removed)
  const handleOpenPlannedQtyDialog = (componentData) => {
    // Directly open the edit dialog without confirmation
    setSelectedLotData(componentData);
    setrmPmCode(componentData?.componentAllocationDetails?.componentCode);
    setOpenDialog(true);
  };

  // Function to open dialog with specific inventoryDetails
  const handleOpenDialog = (lotData, rmPmCode) => {
    setSelectedLotData(lotData);
    setrmPmCode(rmPmCode);
    setOpenDialog(true);
  };

  // Function to close dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedLotData(null);
  };

  // Function to open delete dialog
  const handleOpenDeleteDialog = (lot, component) => {
    setSelectedLotForDelete(lot);
    setSelectedComponentForDelete(component);
    setOpenDeleteDialog(true);
  };

  // Function to close delete dialog
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedLotForDelete(null);
    setSelectedComponentForDelete(null);
  };

  // Handle delete success/failure
  const handleDeleteStatus = (type) => {
    if (type === "success") {
      setDeleteSuccessDialogOpen(true);
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  // Function to open planned batch number edit mode directly (confirmation removed)
  const handleOpenPlannedBatchDialog = (
    rowData,
    componentData,
    componentIndex
  ) => {
    // Directly enable edit mode without confirmation
    const rowKey = `${componentData?.componentAllocationDetails?.componentCode}-${componentIndex}`;
    setEditingBatchRow(rowKey);
    // Pre-populate with existing planned lot numbers if available
    setPlannedBatchNumber(
      normalizeClearedValue(componentData?.componentAllocationDetails?.plannedLotNumbers)
    );
    // Store the component data for later use in save
    setPlannedBatchDialog({
      open: false,
      rowData: rowData,
      componentData: componentData,
      componentIndex: componentIndex,
    });
  };

  const getOrganizationIdFromToken = () => {
    const authToken = localStorage.getItem("authToken"); // Get token from localStorage
    if (!authToken) return null; // Return null if no token is found

    try {
      const decodedToken = jwtDecode(authToken); // Decode the JWT token
      return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
    } catch (error) {
      console.error("Error decoding JWT token:", error);
      return null;
    }
  };
  const collaboratorTypeID = getOrganizationIdFromToken();

  // Function to save planned batch number
  const handleSavePlannedBatch = async () => {
    const componentData = plannedBatchDialog.componentData;
    const existingValue = normalizeClearedValue(
      componentData?.componentAllocationDetails?.plannedLotNumbers
    );

    // Clean up the input: remove trailing/leading commas and extra spaces
    const cleanedBatchNumber = plannedBatchNumber.trim()
      ? plannedBatchNumber
          .split(",")
          .map((batch) => batch.trim())
          .filter((batch) => batch.length > 0)
          .join(", ")
      : "";

    // Allow empty string only if there's an existing value to clear
    // Prevent empty API calls for new entries
    if (!cleanedBatchNumber && !existingValue) {
      return;
    }

    setTableLoading(true);
    try {
      const componentData = plannedBatchDialog.componentData;

      const payload = {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
   
        dateChangeFlag: false,
        collabrixProductID: "",
        collaboratorTypeID: collaboratorTypeID,
        overAllocationDone: null,
        updatePlannedBatchFlag: true,
        // BCM-891: CMO configuration forwarded per the API doc — see cmoPdfConfig.
        ...cmoPdfConfig,
        componentAllocationDataList: [
          {
            componentAllocationDetails: {
              componentCode:
                componentData?.componentAllocationDetails?.componentCode,
              deliveryScheduleLineCounter:
                componentData?.componentAllocationDetails
                  ?.deliveryScheduleLineCounter,
              reasonCode: "",
              comment: "",
              // Backend contract: send the literal string "none" when clearing.
              plannedLotNumbers: cleanedBatchNumber || "none",
              // countryOfOrigin: componentData?.componentAllocationDetails?.countryOfOrigin || "",
            },
            previousLotNumberAllocationDetails: [],
            lotNumberAllocationDetails: [],
          },
        ],
      };

      const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;
      // return
      const response = await axios.post(apiUrl, payload);

      if (response.data.status) {
        setEditingBatchRow(null);
        setPlannedBatchNumber("");
        await handleLotAllocationStatus("success", "Planned Material Batch Number updated successfully", false);
      } else {
        await handleLotAllocationStatus("failed");
      }
    } catch (error) {
      console.error("Error saving planned batch number:", error);
      await handleLotAllocationStatus("failed");
    } finally {
      setTableLoading(false);
    }
  };

  // Function to cancel editing
  const handleCancelEdit = () => {
    setEditingBatchRow(null);
    setPlannedBatchNumber("");
    setPlannedBatchDialog({
      open: false,
      rowData: null,
      componentData: null,
    });
  };

  // Country of Origin handlers
  const handleCountryOfOriginChange = (e) => {
    const value = e.target.value;
    setCountryOfOrigin(value);
  };

  const handleCountryOfOriginBlur = () => {
    if (!countryOfOrigin.trim()) return;
    const cleaned = countryOfOrigin.trim();
    setCountryOfOrigin(cleaned);
  };

  const handleEditCountryClick = (component, componentIndex) => {
    const rowKey = `${component?.componentAllocationDetails?.componentCode}-${componentIndex}`;
    setEditingCountryRow(rowKey);
    setCountryOfOrigin(
      component?.componentAllocationDetails?.countryOfOrigin || ""
    );
  };

  const handleSaveCountry = async (component) => {
    const existingValue =
      component?.componentAllocationDetails?.countryOfOrigin;
    const cleanedCountry = countryOfOrigin.trim();

    // Allow empty string only if there's an existing value to clear
    // Prevent empty API calls for new entries
    if (!cleanedCountry && !existingValue) {
      return;
    }

    setTableLoading(true);
    try {
      const payload = {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
   
        dateChangeFlag: false,
        collabrixProductID: "",
        collaboratorTypeID: collaboratorTypeID,
        overAllocationDone: null,
        updateCountryOfOriginFlag: true,
        // BCM-891: CMO configuration forwarded per the API doc — see cmoPdfConfig.
        ...cmoPdfConfig,
        componentAllocationDataList: [
          {
            componentAllocationDetails: {
              componentCode:
                component?.componentAllocationDetails?.componentCode,
              deliveryScheduleLineCounter:
                component?.componentAllocationDetails
                  ?.deliveryScheduleLineCounter,
              reasonCode: "",
              comment: "",
              countryOfOrigin: cleanedCountry,
              // plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers || "",
            },
            previousLotNumberAllocationDetails: [],
            lotNumberAllocationDetails: [],
          },
        ],
      };

      const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;

      const response = await axios.post(apiUrl, payload);

      if (response.data.status) {
        setEditingCountryRow(null);
        setCountryOfOrigin("");
        await handleLotAllocationStatus("success", "Country of Origin updated successfully", false);
      } else {
        await handleLotAllocationStatus("failed");
      }
    } catch (error) {
      console.error("Error saving country of origin:", error);
      await handleLotAllocationStatus("failed");
    } finally {
      setTableLoading(false);
    }
  };

  const handleCancelCountryEdit = () => {
    setEditingCountryRow(null);
    setCountryOfOrigin("");
  };



  // Only a current or future date is allowed. The native <input type="date" min="...">
  // only blocks the calendar picker in most browsers — typing digits directly into the
  // day/month/year segments bypasses it entirely. Enforce the constraint here
  // explicitly rather than relying on the min attribute alone.
  const handleArrivalDateChange = (e) => {
    const newValue = e.target.value;
    if (newValue) {
      const todayStr = new Date().toISOString().split("T")[0];
      if (newValue < todayStr) {
        return; // ignore past-date entry; field keeps its current value
      }
    }
    setExpectedArrivalDate(newValue);
  };

  // Expected Date of Arrival at CMO is a material-level value on componentAllocationDetails,
  // like plannedLotNumbers/countryOfOrigin. Confirmed against a real captured
  // fetchComponentAllocationForPOLineNewDirect response: the GET/read field name
  // is the plain "expectedDateOfArrivalAtCMO". The save payload to
  // updateComponentAllocationNew uses a different name for the same value —
  // "incomingExpectedDateOfArrivalAtCMO" — per the confirmed write contract.
  const handleEditArrivalDateClick = (component, componentIndex) => {
    const rowKey = `${component?.componentAllocationDetails?.componentCode}-${componentIndex}`;
    const current = component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO;
    setEditingArrivalDateRow(rowKey);
    // The stored value is a full "YYYY-MM-DDTHH:mm:ss.SSS" datetime string, but
    // <input type="date"> requires exactly "YYYY-MM-DD" or it silently shows
    // blank — strip the time portion before seeding the field.
    setExpectedArrivalDate(current && current !== "none" ? current.split("T")[0] : "");
  };

  const handleSaveArrivalDate = async (component) => {
    const rawExisting = component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO;
    const existingValue = rawExisting && rawExisting !== "none" ? rawExisting : "";

    // Allow clearing (empty) only if there was a previously saved value
    if (!expectedArrivalDate && !existingValue) {
      setEditingArrivalDateRow(null);
      return;
    }

    // Defensive backstop for the "no past date" rule — handleArrivalDateChange
    // already rejects past-date entry, but never save one if it somehow got in.
    if (expectedArrivalDate && expectedArrivalDate < new Date().toISOString().split("T")[0]) {
      return;
    }

    // Backend contract: send as "YYYY-MM-DDTHH:mm:ss.SSS" (no timezone suffix),
    // e.g. "2025-07-28T12:40:17.130" — a real save-time timestamp, not midnight.
    // The <input type="date"> only gives the calendar date ("YYYY-MM-DD"), so
    // the time portion is filled with the current wall-clock time at the moment
    // of saving (local time components, kept as plain zero-padded strings so
    // there's no Date-object round-trip that could shift the calendar date
    // across a timezone boundary). Clearing still sends "none".
    const pad = (n, len = 2) => String(n).padStart(len, "0");
    const now = new Date();
    const timePart = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.${pad(now.getMilliseconds(), 3)}`;
    const valueToSend = expectedArrivalDate
      ? `${expectedArrivalDate}T${timePart}`
      : "none";

    setTableLoading(true);
    try {
      // Mirrors the Planned Material Batch Number save: lotNumberAllocationDetails
      // carries the current lot data (empty array if nothing allocated yet — this
      // field doesn't depend on an allocated batch existing).
      const lotNumberAllocationDetails = (component?.lotNumberAllocationDetails || []).map(
        (lot) => ({
          lotNumber: lot?.lotNumber,
          plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
          isDepletedBatch: lot?.isDepletedBatch || false,
          storageLocation: lot?.storageLocation ?? "",
        })
      );

      const payload = {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
     
        dateChangeFlag: false,
        collabrixProductID: "",
        collaboratorTypeID: collaboratorTypeID,
        overAllocationDone: null,
        updateExpectedDateOfArrivalAtCMOFlag: true,
        // BCM-891: CMO configuration forwarded per the API doc — see cmoPdfConfig.
        ...cmoPdfConfig,
        componentAllocationDataList: [
          {
            componentAllocationDetails: {
              componentCode:
                component?.componentAllocationDetails?.componentCode,
              deliveryScheduleLineCounter:
                component?.componentAllocationDetails
                  ?.deliveryScheduleLineCounter,
              reasonCode: "",
              comment: "",
              incomingExpectedDateOfArrivalAtCMO: valueToSend,
            },
            previousLotNumberAllocationDetails: [],
            lotNumberAllocationDetails,
          },
        ],
      };

      const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;

      const response = await axios.post(apiUrl, payload);

      if (response.data.status) {
        setEditingArrivalDateRow(null);
        setExpectedArrivalDate("");
        setTableLoading(true);
        await fetchLotAllocationData();
        handleLotAllocationStatus("success", "Expected Date of Arrival at CMO updated successfully", false);
      } else {
        handleLotAllocationStatus("failed");
      }
    } catch (error) {
      console.error("Error saving expected date of arrival at CMO:", error);
      handleLotAllocationStatus("failed");
    } finally {
      setTableLoading(false);
    }
  };

  const handleCancelArrivalDateEdit = () => {
    setEditingArrivalDateRow(null);
    setExpectedArrivalDate("");
  };

  // Handle continue to generate PDF (opens PDF generation dialog)
  /*
   * BCM-891: all three configurations No means there is nothing to ask the user
   * and no approval to route, so the spec says the "Generating PDF notification
   * for Allocation" popup is not displayed at all — the PDF is generated and
   * shared straight away.
   *
   * Only ever true once the middleware sends the configuration; on a build
   * without it pdfConfigured is false and the popup opens exactly as before.
   */
  const pdfNeedsNoInput =
    pdfConfigured && !cfgDocumentIdReqd && !cfgArtworkReqd && !cfgApprovalReqd;

  /*
   * BCM-891: why the PDF popup, the Generate PDF button or the version block
   * is not on screen.
   *
   * Three separate gates hide them, and only one is the product-type
   * configuration — so "I set all three to Yes and still see nothing" is a
   * question this had no way of answering. Silent unless someone opts in with
   *   localStorage.setItem('bcm891debug', '1')
   * in the console, exactly like the tooltip diagnostic.
   */
  useEffect(() => {
    try {
      if (typeof window === "undefined") return;
      if (window.localStorage.getItem("bcm891debug") !== "1") return;
      // eslint-disable-next-line no-console
      console.log("[BCM-891] PDF / version gates", {
        // Gate 0 — which endpoint fed this screen. A batch with BoM
        // consumption added is served by fetchComponentAllocationPlannedAndActualNew,
        // which returns neither the PDF flag nor the product-type
        // configuration, so the PDF popup cannot appear on that view at all.
        bomConsumptionAdded: !!data?.batchDetails?.bomConsumptionAddedIndicator,
        // Gate 1 — the CMO's own "Batch Allocation Notification PDF Required".
        // False here means no popup and no Generate PDF button, whatever the
        // product type is configured as.
        batchAllocationPDFNotificationReqd,
        // Gate 2 — the product type's configuration, which decides what the
        // popup asks for, not whether there is one.
        pdfConfigured,
        documentIDReqd: lotAllocationRes?.documentIDReqd,
        artworkRequired: lotAllocationRes?.artworkRequired,
        allocationApprovalReqd: lotAllocationRes?.allocationApprovalReqd,
        allocationPDFTitle: lotAllocationRes?.allocationPDFTitle,
        pdfNeedsNoInput,
        // Gate 3 — the version block needs a versionNumber from the API.
        versionNumber: allocationVersionNumber,
        // The rest of the Generate PDF button's conditions.
        generatePDFFeature: featuresAccess?.generatePDF,
        collabType: localStorage.collabType,
        rows: lotAllocationData?.length,
        alreadyGenerated: lotAllocationRes?.generateAllocationPDF,
        approvalRejected: hasApprovalRejection(),
        allPlannedQtyNA: areAllPlannedAllocatedQuantitiesNA(),
      });
    } catch (e) {
      /* diagnostics must never break the screen */
    }
  });

  /*
   * BCM-891: "If a batch allocation PDF was generated earlier for the same PO,
   * the values entered during the last PDF generation are pre-populated in the
   * displayed fields. The user can edit the pre-populated values." And for the
   * repeatable list: "the previously entered artwork codes are pre-populated in
   * the same manner, one textbox per code".
   *
   * Only ever fills a field the user has not already typed into, so re-opening
   * the popup after an edit never discards their work. Does nothing while the
   * middleware sends no configuration, where the popup keeps its old behaviour.
   */
  const prefillPdfFieldsFromLastGeneration = () => {
    if (!pdfConfigured) return;

    const lastDocumentId = lotAllocationRes?.documentID;
    if (cfgDocumentIdReqd && lastDocumentId && !documentId) {
      setDocumentId(String(lastDocumentId));
    }

    if (!cfgArtworkReqd) return;
    const alreadyTyped = artworkCodes.some((c) => String(c || "").trim() !== "");
    if (alreadyTyped) return;
    // multipleArtworkCodes holds every code; artworkCode only ever held the
    // first, so it is the fallback for a PO generated before the list existed.
    const previous = String(
      lotAllocationRes?.multipleArtworkCodes || lotAllocationRes?.artworkCode || ""
    )
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean);
    if (previous.length > 0) setArtworkCodes(previous);
  };

  const handleContinueToGeneratePdf = () => {
    // Close the first success dialog and open PDF generation dialog
    setEditSuccessDialogOpen(false);
    setShowPdfGenerationFlow(true); // Reset to default
    setPdfFieldValidationError("");
    if (pdfNeedsNoInput) {
      /*
       * Straight to the same share the button performs, so the rest of the flow
       * is untouched: the same endpoint, the same "Allocation change PDF shared
       * successfully" popup, and the same PDF link against the current version.
       * None of its field validation can fire — every include* flag is false.
       * The popup is still opened, showing only a loader, so the user sees the
       * request is in progress; the share closes it on success.
       */
      setPdfGenerationDialogOpen(true);
      handleShareWithoutApprovals();
      return;
    }
    prefillPdfFieldsFromLastGeneration();
    setPdfGenerationDialogOpen(true);
  };

  // Handle share without approvals
  const handleShareWithoutApprovals = async () => {
    // Validate fields
    if (includeDocumentId && !documentId.trim()) {
      setPdfFieldValidationError("Please enter Document ID");
      return;
    }
    if (includeBomCode && !bomCode.trim()) {
      setPdfFieldValidationError("Please enter BoM Code");
      return;
    }
    // BCM-891: with the configuration in play the repeatable list is validated
    // instead of the single field.
    const artworkErr = artworkCodesError();
    if (artworkErr) {
      setPdfFieldValidationError(artworkErr);
      return;
    }
    if (!pdfConfigured && includeArtworkCode && !artworkCode.trim()) {
      setPdfFieldValidationError("Please enter Artwork Code");
      return;
    }
    
    // Clear validation error if all validations pass
    setPdfFieldValidationError("");
    setSharingWithoutApproval(true);
    try {
      // Extract cc array from teamMembersData
      const ccList = teamMembersData.map(user => user.fullName);
      
      // Construct payload from lotAllocationRes
      const payload = {
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        productType: lotAllocationRes?.productType,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        approvalNotReqd: true,
        approvalWorkflowDetails: [],
        departmentName: localStorage.getItem("departmentName") || "",
        roleName: decodeURIComponent(localStorage.getItem("roleName") || ""),
        cc: ccList,
        documentID: documentId && includeDocumentId ? documentId.trim() : "",
        bomCode: bomCode && includeBomCode ? bomCode.trim() : "",
        artworkCode: pdfConfigured
          ? multipleArtworkCodes
          : artworkCode && includeArtworkCode
          ? artworkCode.trim()
          : "",
        // BCM-891: comma-separated list, the shape /updateApprovalWorkflow documents.
        multipleArtworkCodes: includeArtworkCode ? multipleArtworkCodes : "",
        generateAllocationPDF: true,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
            // Batch Allocation PDF needs this to render the material-level band. Same
            // plain "expectedDateOfArrivalAtCMO" field name as the
            // fetchComponentAllocationForPOLineNewDirect GET response this value was
            // read from — just passed straight through here.
            expectedDateOfArrivalAtCMO: component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO ?? null,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
            isDepletedBatch: lot?.isDepletedBatch || false,
            batchNearExpiry: component?.inventoryDetails?.find(inv => inv?.inventoryBatchNumber === lot?.lotNumber)?.batchNearExpiry || false,
            // Send explicit null (not omitted) when no value is held.
            dateOfManufacturing: lot?.inventoryManufacturingDate ?? null,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
            dateOfManufacturing: inv?.inventoryManufacturingDate ?? null,
          })) || [],
        })) || [],
        /*
         * BCM-891: the four CMO-configuration values, which this call was the
         * only PDF path not to send. generateBatchAllocationPDF decides from
         * them which sections to print and which title to use, and reads them
         * off the request body with no fallback — so without them a product
         * type with Document ID Required or Artwork Code Required = Yes had its
         * values captured in the popup and then left out of the PDF.
         *
         * Empty object while the middleware does not send the configuration, so
         * the payload stays byte-identical on a build without it.
         */
        ...cmoPdfConfig,
      };

      // Call the API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationWithoutApproval`;
      
      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        // Close PDF generation dialog and show success dialog
        // Fetch updated data once (retry logic removed)
        await fetchLotAllocationData();
        setPdfGenerationDialogOpen(false);
        setPdfFieldValidationError("");
        setEditSuccessMessage("");
        setDocumentId("");
        setBomCode("");
        setArtworkCode("");
        setArtworkCodes([""]);
        setShareSuccessDialogOpen(true);
      } else {
        // Handle error
        console.error("Failed to process batch allocation:", response.data);
        setSaveFailed(true);
      }
    } catch (error) {
      console.error("Error sharing without approvals:", error);
      setSaveFailed(true);
    } finally {
      setSharingWithoutApproval(false);
    }
  };

  // Handle share after approvals
  const handleShareAfterApprovals = () => {
    // Validate fields
    if (includeDocumentId && !documentId.trim()) {
      setPdfFieldValidationError("Please enter Document ID");
      return;
    }
    if (includeBomCode && !bomCode.trim()) {
      setPdfFieldValidationError("Please enter BoM Code");
      return;
    }
    // BCM-891: with the configuration in play the repeatable list is validated
    // instead of the single field.
    const artworkErr = artworkCodesError();
    if (artworkErr) {
      setPdfFieldValidationError(artworkErr);
      return;
    }
    if (!pdfConfigured && includeArtworkCode && !artworkCode.trim()) {
      setPdfFieldValidationError("Please enter Artwork Code");
      return;
    }
    
    // Clear validation error if all validations pass
    setPdfFieldValidationError("");
    
    // Close PDF generation dialog and open workflow dialog
    // Reset approvers data and clear validation errors (but keep documentId)
    setApprovers([
      { id: 1, requirement: "Approval", approverOrg: "Internal", assignedMember: "", signature: "Electronic", changeOrder: "" }
    ]);
    setWorkflowValidationError("");
    nextApproverID.current = 2;
    // API call to fetch team members will be triggered by useEffect
    setPdfGenerationDialogOpen(false);
    setWorkflowDialogOpen(true);
  };

  // Handle allocate batch for remaining materials/components
  const handleAllocateRemainingMaterials = () => {
    // Close the success dialog so user can continue editing
    setEditSuccessDialogOpen(false);
    setEditSuccessMessage("");
    setShowPdfGenerationFlow(true); // Reset to default
  };

  // Handle add approver
  const handleAddApprover = () => {
    const newApprover = {
      id: nextApproverID.current,
      requirement: "Approval",
      approverOrg: "Internal",
      assignedMember: "",
      signature: "Electronic",
      changeOrder: ""
    };
    nextApproverID.current += 1;
    setApprovers([...approvers, newApprover]);
  };

  // Handle remove approver
  const handleRemoveApprover = (id) => {
    setApprovers(approvers.filter(approver => approver.id !== id));
  };

  // Handle update assigned member
  const handleUpdateAssignedMember = (id, value) => {
    setApprovers(approvers.map(approver => 
      approver.id === id ? { ...approver, assignedMember: value } : approver
    ));
    // Clear validation error when user starts assigning members
    if (value && value.trim() !== "" && workflowValidationError) {
      setWorkflowValidationError("");
    }
  };

  // Handle save workflow
  const handleSaveWorkflow = async () => {
    try {
      // Validate that all approver rows have assigned members
      const unassignedApprovers = approvers.filter(approver => 
        !approver.assignedMember || approver.assignedMember.trim() === ""
      );
      
      if (unassignedApprovers.length > 0) {
        setWorkflowValidationError("Please select an approver for all the rows.");
        return;
      }
      
      // Clear validation error if exists
      setWorkflowValidationError("");
      setSavingWorkflow(true);
      // Check if this is initial approval workflow setup
      const isInitialSetup = !lotAllocationRes?.approvalWorkflowDetails || 
                             lotAllocationRes?.approvalWorkflowDetails.length === 0;
      
      // Map approvers to approval workflow details
      const approvalWorkflowDetails = approvers.map((approver, index) => ({
        requirementType: approver.requirement, // "Approval" or "Review"
        stakeHolderType: approver.approverOrg, // "Internal" or "External"
        decisionBy: approver.assignedMember, // Email address (stored directly)
        eSignatureRequired: approver.signature === "Electronic",
        digitalSignatureRequired: approver.signature === "Digital",
        sequenceNumber: index + 1,
        enableApprovalFlag: true
      }));
      
      // Extract cc array from teamMembersData
      const ccList = teamMembersData.map(user => user.fullName);
      
      // Build request payload
      const payload = {
        batchAllocationSentForApprovalBy:lotAllocationRes?.batchAllocationSentForApprovalBy,
        batchAllocationSentForApprovalDate:lotAllocationRes?.batchAllocationSentForApprovalDate,
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        documentID: documentId ? documentId.trim() : "",
        initialApprovalWorkflowSetup: isInitialSetup,
        approvalWorkflowDetails: approvalWorkflowDetails,
        approvalNotReqd: false,
        cc: ccList,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        bomCode: bomCode && includeBomCode ? bomCode.trim() : "",
        artworkCode: pdfConfigured
          ? multipleArtworkCodes
          : artworkCode && includeArtworkCode
          ? artworkCode.trim()
          : "",
        // BCM-891: comma-separated list, the shape /updateApprovalWorkflow documents.
        multipleArtworkCodes: includeArtworkCode ? multipleArtworkCodes : "",
        generateAllocationPDF: true,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
            // See handleShareWithoutApprovals above — same plain field name required
            // by this endpoint's own payload contract.
            expectedDateOfArrivalAtCMO: component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO ?? null,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
            //isDepletedBatch: lot?.isDepletedBatch || false,
            batchNearExpiry: component?.inventoryDetails?.find(inv => inv?.inventoryBatchNumber === lot?.lotNumber)?.batchNearExpiry || false,
            // Send explicit null (not omitted) when no value is held.
            dateOfManufacturing: lot?.inventoryManufacturingDate ?? null,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
            dateOfManufacturing: inv?.inventoryManufacturingDate ?? null,
          })) || [],
        })) || [],
      };


      // Call middleware API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationApprovals`;
      
      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        // Close workflow dialog and show success
        // Fetch updated data once (retry logic removed)
        await fetchLotAllocationData();
        setSavingWorkflow(false);
        setWorkflowDialogOpen(false);
        setPdfFieldValidationError("");
        setDocumentId("");
        setBomCode("");
        setArtworkCode("");
        setArtworkCodes([""]);
        setShareSuccessDialogOpen(true);
      } else {
        // Handle error
        console.error("Failed to process batch allocation approvals:", response.data);
        setSavingWorkflow(false);
        setSaveFailed(true);
      }
    } catch (error) {
      console.error("Error saving workflow:", error);
      setSavingWorkflow(false);
      setSaveFailed(true);
    }
  };

  // Function to handle PDF download from API response base64 data
  const handleDownloadPdfFromBase64 = () => {
    if (!lotAllocationRes?.pdfBase64) {
      console.error('No PDF base64 data available');
      return;
    }

    const fullPoNumber = data?.scheduleLineDetails?.scheduleAgreementNumber || '';
    const productCode = data?.scheduleLineDetails?.fgMaterialCode || '';
    
    // Extract latest lastUpdatedDate from lotNumberAllocationDetails across all components
    let latestDate = '';
    if (lotAllocationRes?.componentAllocationDataList && lotAllocationRes.componentAllocationDataList.length > 0) {
      const allDates = [];
      
      // Iterate through all components
      lotAllocationRes.componentAllocationDataList.forEach(component => {
        // Get dates from lotNumberAllocationDetails
        if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
          component.lotNumberAllocationDetails.forEach(lot => {
            if (lot?.lastUpdatedDate) {
              allDates.push(lot.lastUpdatedDate);
            }
          });
        }
      });
      
      // Sort dates and get the latest one
      if (allDates.length > 0) {
        const sortedDates = allDates.sort().reverse();
        latestDate = new Date(sortedDates[0]).toISOString().split('T')[0]; // Format as YYYY-MM-DD
      }
    }
    // BCM-891: named after when the last PDF was shared, which may predate the current allocation.
    const pdfMoment = lotAllocationRes?.lastGeneratedPdf?.generatedAt || lotAllocationRes?.lastGeneratedPdf?.allocationDate;
    if (pdfMoment) {
      latestDate = new Date(pdfMoment).toISOString().split('T')[0];
    }
    
    const fileName = latestDate 
      ? `PO_${fullPoNumber}_Batch Allocation_${latestDate}.pdf`
      : `PO_${fullPoNumber}_Batch Allocation.pdf`;
    
    downloadPdfFromBase64(lotAllocationRes.pdfBase64, fileName);
  };

  // Drag and drop handlers
  const [draggedItem, setDraggedItem] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;
    
    const newApprovers = [...approvers];
    const draggedApprover = newApprovers[draggedItem];
    newApprovers.splice(draggedItem, 1);
    newApprovers.splice(index, 0, draggedApprover);
    
    setApprovers(newApprovers);
    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  // Check if current user can approve allocation
  const canUserApprove = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }

    const userEmail = tokenData?.email_address || "";
    
    // Find current user's approval entry
    const userApproval = lotAllocationRes.approvalWorkflowDetails.find(
      (approval) => approval.decisionBy === userEmail && approval.enableApprovalFlag === true
    );

    if (!userApproval) {
      return false;
    }

    // Check if user has already made a decision (approved or rejected)
    if (userApproval.decision !== null && userApproval.decision !== undefined) {
      return false; // User has already approved or rejected, don't show buttons
    }

    // Check if all previous approvals (lower sequence numbers) are completed
    const previousApprovals = lotAllocationRes.approvalWorkflowDetails.filter(
      (approval) => approval.sequenceNumber < userApproval.sequenceNumber
    );

    const allPreviousApproved = previousApprovals.every(
      (approval) => approval.decision === "Approved"
    );

    return allPreviousApproved;
  };

  // Handle approve/reject button click (opens electronic signature dialog)
  const handleApproveRejectAllocation = (decision) => {
    setElectronicSignatureDialog({
      open: true,
      decision: decision, // "Approve" or "Reject"
    });
  };

  // Close electronic signature dialog
  const handleCloseElectronicSignature = () => {
    setElectronicSignatureDialog({
      open: false,
      decision: "",
    });
  };

  // Handle electronic signature success
  const handleElectronicSignatureSuccess = async (status, comments = '') => {
    const decision = electronicSignatureDialog.decision;
    // Set flag to prevent useEffect from interfering
    setIsProcessingApproval(true);
    
    try {
      // Update approval workflow details
      const updatedApprovalWorkflow = lotAllocationRes.approvalWorkflowDetails.map((approval) => {
        if (approval.decisionBy === tokenData?.email_address && approval.enableApprovalFlag === true) {
          return {
            ...approval,
            decision: decision === "Approve" ? "Approved" : "Rejected",
            decisionDate: new Date().toISOString(),
            remarks: comments || '',
            enableApprovalFlag: false,
          };
        }
        return approval;
      });

      // Build request payload
      const payload = {
        batchAllocationSentForApprovalBy:lotAllocationRes?.batchAllocationSentForApprovalBy,
        batchAllocationSentForApprovalDate:lotAllocationRes?.batchAllocationSentForApprovalDate,
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        artworkCode: lotAllocationRes?.artworkCode,
        bomCode: lotAllocationRes?.bomCode,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        approvalNotReqd: false,
        allocationApproved: decision === "Approve",
        approvalWorkflowDetails: updatedApprovalWorkflow,
        generateAllocationPDF: decision === "Approve" ? lotAllocationRes?.generateAllocationPDF : false,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
            // See handleShareWithoutApprovals above — same plain field name required
            // by this endpoint's own payload contract.
            expectedDateOfArrivalAtCMO: component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO ?? null,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
           // isDepletedBatch: lot?.isDepletedBatch || false,
            batchNearExpiry: component?.inventoryDetails?.find(inv => inv?.inventoryBatchNumber === lot?.lotNumber)?.batchNearExpiry || false,
            // Send explicit null (not omitted) when no value is held.
            dateOfManufacturing: lot?.inventoryManufacturingDate ?? null,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
            dateOfManufacturing: inv?.inventoryManufacturingDate ?? null,
          })) || [],
        })) || [],
      };




      // Call middleware API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationApprovals`;

      const response = await axios.post(url, payload);

      if (response.data.status) {
        // Close electronic signature dialog
        setElectronicSignatureDialog({
          open: false,
          decision: "",
        });
        
        // Show success message
        // Note: setIsProcessingApproval(false) will be called when OK button is clicked
        setApproveRejectSuccess({
          open: true,
          type: decision,
        });
      } else {
        console.error("Failed to process approval:", response.data);
        setSaveFailed(true);
        // Reset flag on error
        setIsProcessingApproval(false);
      }
    } catch (error) {
      console.error("Error processing approval:", error);
      setSaveFailed(true);
      // Reset flag on error
      setIsProcessingApproval(false);
    }
  };

  // Function to generate approval workflow note message
  const generateApprovalNote = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return null;
    }

    const approvalWorkflow = lotAllocationRes.approvalWorkflowDetails;
    const sentBy = lotAllocationRes?.sentForApprovalBy || null;
    const sentForApprovalTo = lotAllocationRes?.sentForApprovalTo || null;
    const approvedByApproverNames = lotAllocationRes?.approvedByApproverNames || [];
    

    
    // Filter approvers with enableApprovalFlag = true (pending approvals)
    const pendingApprovers = approvalWorkflow.filter(item => item.enableApprovalFlag === true && !item.decision);
    
    // Filter approvers who have already taken action (approved/rejected)
    const completedApprovers = approvalWorkflow.filter(item => item.decision || item.enableApprovalFlag === false);
    
    // Sort by sequence number to maintain order
    const sortedPending = [...pendingApprovers].sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    const sortedCompleted = [...completedApprovers].sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    
    let message = "";
    
    // Case 1: All approvals done
    if (pendingApprovers.length === 0 && completedApprovers.length > 0) {
      // Use approvedByApproverNames if available, otherwise fallback to decisionBy
      const approverNames = approvedByApproverNames.length > 0 
        ? approvedByApproverNames.map(name => `'${name}'`).join(" and ")
        : sortedCompleted.map(item => `'${item.decisionBy}'`).join(" and ");
      message = `Component allocation approved by ${approverNames}.`;
    }
    // Case 2: Some approvals done, some pending
    else if (completedApprovers.length > 0 && pendingApprovers.length > 0) {
      // Use approvedByApproverNames for completed approvals
      const completedNames = approvedByApproverNames.length > 0 
        ? approvedByApproverNames.map(name => `'${name}'`).join(" and ")
        : sortedCompleted.map(item => `'${item.decisionBy}'`).join(" and ");
      // Use sentForApprovalTo for next pending approver
      const nextApproverName = sentForApprovalTo || sortedPending[0]?.decisionBy;
      message = `Component allocation approved by ${completedNames} and sent for approval to '${nextApproverName}' by ${sentBy}.`;
    }
    // Case 3: Initial state - sent for approval to first approver
    else if (completedApprovers.length === 0 && pendingApprovers.length > 0) {
      // Use sentForApprovalTo for the first pending approver
      const firstApproverName = sentForApprovalTo || sortedPending[0]?.decisionBy;
      message = `Component allocation sent for approval to '${firstApproverName}' by ${sentBy}.`;
    }
    
    return message;
  };

  const approvalNote = generateApprovalNote();

  // Function to check if all approvals are complete
  const areAllApprovalsComplete = () => {
    // If no approval workflow exists or it's empty, check if pdfBase64 exists
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      // Enable download if pdfBase64 exists when approval workflow is empty
      return !!lotAllocationRes?.pdfBase64;
    }

    const approvalWorkflow = lotAllocationRes.approvalWorkflowDetails;
    
    // Check if all approvers have approved
    const allApproved = approvalWorkflow.every(item => item.decision === "Approved");
    return allApproved;
  };

  // Function to check if approval workflow has any rejection
  const hasApprovalRejection = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }
    return lotAllocationRes.approvalWorkflowDetails.some(item => item.decision === "Rejected");
  };

  // Function to check if approval workflow exists
  const hasApprovalWorkflow = () => {
    return lotAllocationRes?.approvalWorkflowDetails && lotAllocationRes.approvalWorkflowDetails.length > 0;
  };

  // Function to check if any approver has enableApprovalFlag set to true
  const hasEnabledApprovalFlag = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }
    return lotAllocationRes.approvalWorkflowDetails.some(approver => approver.enableApprovalFlag === true);
  };



  // const handleConfirmAllocation = async (lotNumber, lot, data) => {
  //   try {
  //     const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
  //     const cdmoOrgID = data?.scheduleLineDetails?.vendorMosymphonyID;

  //     const selectedLotDetails = lot.lotNumberAllocationDetails.find(lotItem => lotItem.lotNumber === lotNumber);

  //     if (!selectedLotDetails) {
  //       console.error("Lot number not found in allocation details.");
  //       return;
  //     }

  //     const requestData = {
  //       schrockenSLID,
  //       cdmoOrgID,
  //       dateChangeFlag: false,
  //       componentAllocationDataList: [
  //         {
  //           componentAllocationDetails: {
  //             componentCode: lot.componentAllocationDetails.componentCode,
  //             deliveryScheduleLineCounter: lot.componentAllocationDetails.deliveryScheduleLineCounter,
  //           },
  //           previousLotNumberAllocationDetails: [],
  //           lotNumberAllocationDetails: [
  //             {
  //               lotNumber: selectedLotDetails.lotNumber,
  //               plannedAllocatedQuantity: selectedLotDetails.plannedAllocatedQuantity,
  //             },
  //           ],
  //         },
  //       ],
  //     };

  //     const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;

  //     await axios.post(apiUrl, requestData);

  //   } catch (error) {
  //     console.error("Error in handleConfirmAllocation:", error);
  //   }
  // };



  return (
    <React.Fragment>
      {data?.batchDetails &&
      data?.batchDetails?.bomConsumptionAddedIndicator ? (
        <ViewRmPmLotTable
          apiData={lotAllocationData}
          loading={tableLoading}
          error={error}
          batchDetails={data?.batchDetails}
        />
      ) : (
        <>
          {/* BCM-891: confirmation banner for a request raised from the tooltip.
              Dismissable, and it does not change the state of the edit button. */}
          {accessRequest && (
            <Box
              style={{
                marginTop: "1rem",
                padding: "10px 14px",
                borderRadius: 4,
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                // BCM-891: "info" is the already-requested answer — nothing
                // failed, but nothing new was sent either, so it reads as
                // neither green nor red.
                border: `1px solid ${
                  accessRequest.severity === "success"
                    ? "#a5d6a7"
                    : accessRequest.severity === "info"
                    ? "#ffcc80"
                    : "#ef9a9a"
                }`,
                backgroundColor:
                  accessRequest.severity === "success"
                    ? "#edf7ed"
                    : accessRequest.severity === "info"
                    ? "#fff8e1"
                    : "#fdecea",
              }}
            >
              {/* Same wording as the tooltip note, so it is set at the same
                  size — body2 is 14px and was smaller than the tooltip it
                  confirms. */}
              <Typography
                variant="body2"
                style={{ flex: 1, color: "#1c1c1e", fontSize: 16, lineHeight: 1.6 }}
              >
                {accessRequest.text}
              </Typography>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={() => setAccessRequest(null)}
                style={{ color: "#5f6368", fontWeight: 600 }}
              >
                Dismiss
              </Link>
            </Box>
          )}

          <TableContainer
            style={{ marginTop: "1rem", minHeight: "auto", maxHeight: "400px" }}
            component={Paper}
            className={classes.tableContainer}
          >
          <Table stickyHeader className="default-table-styles">
            {/* Table Head */}
            <TableHead>
              {/* Main header row */}
              <TableRow style={{ width: "100%" }}>
                {/* First three columns stay fixed in view on horizontal scroll. */}
                <TableCell
                  style={{ width: "23%", minWidth: "170px" }}
                  align="left"
                  className={`${classes.headerCell} ${classes.stickyHeaderCol1}`}
                >
                  BMS Material Code / Description
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "90px" }}
                  align="right"
                  className={`${classes.headerCell} ${classes.stickyHeaderCol2}`}
                >
                  Material BoM Qty.
                </TableCell>
                <TableCell
                  style={{ width: "11%", paddingLeft: "3%", minWidth: "90px" }}
                  align="left"
                  className={`${classes.headerCell} ${classes.stickyHeaderCol3}`}
                >
                  UoM
                </TableCell>
                {/* BCM-234 F9: Storage Location ID column — Batch Allocation
                    view only (bomConsumptionAddedIndicator === false).
                    Empty when no SLoc info is available on the allocated lot. */}
                <TableCell
                  style={{ width: "11%" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Storage Location ID
                </TableCell>
                <TableCell
                  style={{ width: "11%", whiteSpace: "nowrap" }}
                  align="left"
                  className={classes.headerCell}
                >
                  BMS Material Batch Number
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "92px" }}
                  align="right"
                  className={classes.headerCell}
                >
                  Net Available Qty.
                </TableCell>
                {/* BCM-234: On-Hand Qty. column — Batch Allocation view.
                    Sourced from the same fetchComponentAllocationForPOLine API
                    (onHandQuantity), lot first then inventoryDetails fallback. */}
                <TableCell
                  style={{ width: "11%", minWidth: "92px" }}
                  align="right"
                  className={classes.headerCell}
                >
                  On-Hand Qty.
                </TableCell>
                {/* Date of Manufacturing — display only, sourced from the batch record. */}
                <TableCell
                  style={{ width: "11%", minWidth: "110px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Date of Manufacturing
                </TableCell>
                <TableCell
                  style={{ width: "16%", paddingLeft: "3%", minWidth: "110px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Expiry Date
                </TableCell>
                <TableCell
                  style={{ width: "16%", whiteSpace: "nowrap" }}
                  align="right"
                  className={classes.headerCell}
                >
                  Planned Allocated Qty.
                </TableCell>
                {/* Deplete Instruction — reflects the Add Deplete Instruction checkbox
                    state from the Edit Material Planned Allocated Qty. popup.
                    Non-clickable here; it cannot be set or cleared from this tab. */}
                <TableCell
                  style={{ width: "10%", minWidth: "90px" }}
                  align="center"
                  className={classes.headerCell}
                >
                  Deplete Instruction
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "130px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Planned Material Batch Number
                  <IconButton
                    size="small"
                    onClick={() => setInfoDialogOpen(true)}
                    style={{ marginLeft: "4px", padding: "4px" }}
                  >
                    <InfoOutlinedIcon
                      style={{ fontSize: "18px", color: "#666" }}
                    />
                  </IconButton>
                </TableCell>
                {/* Expected Date of Arrival at CMO — editable by BMS Planner
                    users only; display only for all other users. Not mandatory. */}
                <TableCell
                  style={{ width: "13%", minWidth: "150px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Expected Date of Arrival at CMO
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "100px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Country of Origin
                </TableCell>
                {/* <TableCell className={classes.headerCell}>
                RM/PM lot MFG start date
              </TableCell>
              <TableCell className={classes.headerCell}>
                RM/PM lot MFG dispatch date
              </TableCell>
              <TableCell className={classes.headerCell}>
                RM/PM lot MFG receipt date
              </TableCell> */}
              </TableRow>
            </TableHead>
            {/* Table Body */}
            {tableLoading ? (
              <TableBody>
                <TableRow>
                  {/* BCM-234 F9: colSpan bumped 9 -> 10 after adding Storage Location ID column. */}
                  <TableCell colSpan={14}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : error ? (
              <TableBody>
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell
                    style={{ padding: "10px" }}
                    colSpan={14}
                    align="center"
                  >
                    Something went wrong. Please try again later.
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {/* 
                  Table rendering logic:
                  1. If lotNumberAllocationDetails has data -> show lot allocation rows
                  2. If inventoryDetails has data (length > 0 and < 4) -> show inventory rows  
                  3. Else -> show component data with "NA" values (fallback case)
                  
                  Note: Previously, the condition was just "inventoryDetails.length < 4" which 
                  caused empty arrays to trigger inventory mapping but render nothing.
                  Fixed to check "length > 0 AND length < 4" so empty arrays fall through 
                  to the component data display case.
                */}
                {lotAllocationData?.length > 0 ? (
                  lotAllocationData.map((component, index) => (
                    <React.Fragment key={index}>
                      {/* Case 1: Display lot allocation data if available */}
                      {component?.lotNumberAllocationDetails.length > 0 ? (
                        component?.lotNumberAllocationDetails.map(
                          (lot, lotIndex) => {
                            // Spanning columns (and the first row's own cells) are
                            // top-aligned with the first batch row, rather than centred
                            // across the row group, only when the span actually covers
                            // multiple lot allocation rows — a single-row span keeps the
                            // default (middle) alignment. Also kept fixed on horizontal scroll.
                            const spanVerticalAlign =
                              lotIndex === 0 &&
                              component.lotNumberAllocationDetails.length > 1
                                ? "top"
                                : "middle";
                            return (
                            <TableRow style={{ width: "100%" }} key={lotIndex}>
                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "23%",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                  className={classes.stickyCol1}
                                >
                                  <div>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.componentCode,
                                      ""
                                    )}{" "}
                                    {"/"}
                                  </div>
                                  <div>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.componentName,
                                      ""
                                    )}
                                  </div>
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "11%",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="right"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                  className={classes.stickyCol2}
                                >
                                  {component?.componentAllocationDetails
                                    ?.componentQuantity !== undefined &&
                                  component?.componentAllocationDetails
                                    ?.componentQuantity !== null
                                    ? Number(
                                        component?.componentAllocationDetails
                                          ?.componentQuantity
                                      ).toFixed(3)
                                    : ""}
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "11%",
                                    paddingLeft: "3%",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                  className={classes.stickyCol3}
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails?.uom,
                                    ""
                                  )}
                                </TableCell>
                              )}

                              <TableCell
                                style={{
                                  width: "11%",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="left"
                              >
                                {/* Storage Location ID.
                                    - real value           → show it
                                    - present but null/""   → "Special Stocks with Vendor" (BCM-234 wording)
                                      (backend explicitly says the lot has no SLoc)
                                    - field not sent at all (undefined) → blank, so rows
                                      the backend never populated aren't mislabelled. */}
                                {(() => {
                                  const sl = lot?.storageLocation;
                                  if (sl === undefined) return "";
                                  if (sl && String(sl).trim() !== "") return sl;
                                  return "Special Stocks with Vendor";
                                })()}
                              </TableCell>

                              {/* Lot-Specific Data */}
                              <TableCell
                                style={{
                                  width: "11%",
                                  whiteSpace: "nowrap",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="left"
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                  {lot?.lotNumber || ""}
                                  {(() => {
                                    const inv = component?.inventoryDetails?.find(i => i?.inventoryBatchNumber === lot?.lotNumber);
                                    const isExpired = inv?.inventoryExpiryDate && new Date(inv.inventoryExpiryDate) < new Date();
                                    if (isExpired) return (
                                      <FlagIcon style={{ color: "red", fontSize: 16, stroke: "black", strokeWidth: 1.5 }} />
                                    );
                                    if (inv?.batchNearExpiry === true) return (
                                      <FlagIcon style={{ color: "yellow", fontSize: 16, stroke: "black", strokeWidth: 1.5 }} />
                                    );
                                    return null;
                                  })()}
                                </div>
                              </TableCell>
                              {/* Check if netAvailableQuantity exists before displaying */}
                              <TableCell
                                style={{
                                  width: "11%",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="right"
                              >
                                {formatNetAvailableQty(lot?.netAvailableQuantity)}
                              </TableCell>
                              {/* On-Hand Qty. per allocated lot. Tries the lot itself
                                  first (onHandQuantity), then falls back to the
                                  matching inventory record by batch number. Empty
                                  when no on-hand value is available. */}
                              <TableCell
                                style={{
                                  width: "11%",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="right"
                              >
                                {(() => {
                                  const direct = lot?.onHandQuantity;
                                  if (direct !== undefined && direct !== null && direct !== "") {
                                    return presentFormatedData(direct);
                                  }
                                  const inv = component?.inventoryDetails?.find(
                                    (i) => i?.inventoryBatchNumber === lot?.lotNumber
                                  );
                                  const onHandFromInv = inv?.onHandQuantity;
                                  return onHandFromInv !== undefined && onHandFromInv !== null && onHandFromInv !== ""
                                    ? presentFormatedData(onHandFromInv)
                                    : "";
                                })()}
                              </TableCell>
                              {/* Date of Manufacturing — display only, sourced from the
                                  batch record (lot itself, or the matching inventory
                                  record by batch number as a fallback). */}
                              <TableCell
                                style={{
                                  width: "11%",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="left"
                              >
                                {(() => {
                                  const direct = lot?.dateOfManufacturing;
                                  if (direct) {
                                    return dateFormated(direct, "DD-MMM-YYYY", "").toUpperCase();
                                  }
                                  const inv = component?.inventoryDetails?.find(
                                    (i) => i?.inventoryBatchNumber === lot?.lotNumber
                                  );
                                  return inv?.dateOfManufacturing
                                    ? dateFormated(inv.dateOfManufacturing, "DD-MMM-YYYY", "").toUpperCase()
                                    : "";
                                })()}
                              </TableCell>
                              <TableCell
                                style={{
                                  width: "16%",
                                  paddingLeft: "3%",
                                  verticalAlign: spanVerticalAlign,
                                }}
                                align="left"
                              >
                                {dateFormated(
                                  lot?.expiryDate,
                                  "DD-MMM-YYYY",
                                  ""
                                ).toUpperCase()}
                              </TableCell>

                              {/* <TableCell style={{width:"16%",whiteSpace:"nowrap"}} align="right">
                                {lot?.plannedAllocatedQuantity} */}
                              {/* {(localStorage.collabType !== "CMO" && lotIndex ===
                                  component.lotNumberAllocationDetails.length -
                                  1) && (
                                    // lot.defaultAllocation ? (
                                    //   <IconButton onClick={() => handleConfirmAllocation(lot.lotNumber, component, data)}>
                                    //     <CheckCircleOutlineIcon style={{ fontSize: "large", color: "#28a745" }} />
                                    //   </IconButton>
                                    // ) : (
                                    //   <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                    //     <EditIcon style={{ fontSize: "large", color: "#000000" }} />
                                    //   </IconButton>
                                    // )
                                    <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                      <EditIcon style={{ fontSize: "large", color: "#000000" }} />
                                    </IconButton>
                                  )} */}

                              {/* {showPencilButton &&
                                  localStorage.collabType !== "CMO" &&
                                  featuresAccess?.editPlannedAllocatedQty &&
                                  //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                  lotIndex ===
                                    component.lotNumberAllocationDetails
                                      .length -
                                      1 && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDialog(
                                          component,
                                          component?.componentAllocationDetails
                                            ?.componentCode
                                        )
                                        }
                                      >
                                        <EditIcon
                                          fontSize="large"
                                          style={{
                                            color: "#ec6535",
                                          }}
                                        />
                                      </IconButton>
                                )}
                                      {data?.scheduleLineDetails?.editLotAllocationTab === true && (
                                      <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                        <EditIcon
                                          fontSize="large"
                                          style={{
                                            color:
                                              component.lotNumberAllocationDetails.length > 0
                                                ? "#ec6535"
                                                : "#e36e39",
                                          }}
                                        />
                                      </IconButton>
                                    )} */}

                              {/* <EditPlannedAllocatedQuantity
                                inventoryDetails={component.inventoryDetails}
                                initialValue={lot?.plannedAllocatedQuantity}
                              /> */}
                              {/* </TableCell> */}

                              <TableCell
                                style={{
                                  verticalAlign: spanVerticalAlign,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      minWidth: "40px",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {formatNetAvailableQty(lot?.plannedAllocatedQuantity)}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {
                                      <>
                                        {(() => {
                                          const allocatedQty =
                                            localStorage.collabType === "CMO"
                                              ? lot?.boPlannedAllocatedQuantity
                                              : lot?.plannedAllocatedQuantity;
                                          const isNA =
                                            allocatedQty === null ||
                                            allocatedQty === undefined ||
                                            allocatedQty === "" ||
                                            allocatedQty === "NA" ||
                                            Number(allocatedQty) === 0;
                                          // Same Planned Allocated Qty. editor as
                                          // the other two branches — handleOpenDialog
                                          // and handleOpenPlannedQtyDialog open the
                                          // same dialog — so it carries the same
                                          // explanation when it is greyed out.
                                          return withLockTooltip(
                                            <IconButton
                                              onClick={() =>
                                                handleOpenDialog(
                                                  component,
                                                  component
                                                    ?.componentAllocationDetails
                                                    ?.componentCode
                                                )
                                              }
                                              disabled={!canEditFields}
                                              className={classes.editIconButton}
                                              size="small"
                                            >
                                              <EditIcon
                                                fontSize={
                                                  isNA ? "large" : "small"
                                                }
                                                style={{
                                                  color: "#ec6535",
                                                }}
                                              />
                                            </IconButton>
                                          );
                                        })()}
                                        {/* Show delete icon only if there's an allocated quantity */}
                                        {(() => {
                                          const allocatedQty =
                                            localStorage.collabType === "CMO"
                                              ? lot?.boPlannedAllocatedQuantity
                                              : lot?.plannedAllocatedQuantity;
                                          const hasAllocatedQty =
                                            allocatedQty !== null &&
                                            allocatedQty !== undefined &&
                                            allocatedQty !== "" &&
                                            allocatedQty !== "NA" &&
                                            Number(allocatedQty) > 0;
                                          return hasAllocatedQty ? (
                                            <IconButton
                                              onClick={() =>
                                                handleOpenDeleteDialog(
                                                  lot,
                                                  component
                                                )
                                              }
                                              disabled={!canEditFields}
                                              className={classes.editIconButton}
                                              size="small"
                                              //style={{ padding: "4px", width: "28px", height: "28px" }}
                                            >
                                              <DeleteIcon
                                                fontSize="small"
                                                style={{
                                                  color: "#ec6535",
                                                }}
                                              />
                                            </IconButton>
                                          ) : null;
                                        })()}
                                      </>
                                    }
                                  </div>
                                </div>
                              </TableCell>

                              {/* Deplete Instruction — read-only indicator, greyed out,
                                  shown checked when a deplete instruction is held against
                                  this batch. The column is left BLANK (no checkbox at all)
                                  when no instruction is held — not an unchecked checkbox.
                                  Cannot be set/cleared here. */}
                              <TableCell
                                align="center"
                                style={{
                                  verticalAlign: spanVerticalAlign,
                                }}
                              >
                                {lot?.isDepletedBatch && (
                                  <Checkbox
                                    checked
                                    disabled
                                    className={classes.customCheckbox}
                                    size="small"
                                  />
                                )}
                              </TableCell>

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "11%",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {editingBatchRow ===
                                  `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "4px",
                                      }}
                                    >
                                      <TextField
                                        placeholder="164859141N, 164859142N"
                                        value={plannedBatchNumber}
                                        onChange={
                                          handlePlannedBatchNumberChange
                                        }
                                        onBlur={handlePlannedBatchNumberBlur}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1}
                                        InputProps={{
                                          style: {
                                            fontSize: "14px",
                                            lineHeight: "1.4",
                                            padding: "8px 12px",
                                          },
                                        }}
                                        style={{ backgroundColor: "#fff" }}
                                      />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "3px",
                                        }}
                                      >
                                        <span title="save">
                                          <SaveIcon
                                            onClick={
                                              plannedBatchNumber.trim() ||
                                              component
                                                ?.componentAllocationDetails
                                                ?.plannedLotNumbers
                                                ? handleSavePlannedBatch
                                                : undefined
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                        <span title="clear">
                                          <ClearIcon
                                            onClick={handleCancelEdit}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                      </Box>
                                    </div>
                                  ) : (
                                    <>
                                      {presentFormatedData(
                                        normalizeClearedValue(
                                          component?.componentAllocationDetails
                                            ?.plannedLotNumbers
                                        ),
                                        ""
                                      )}
                                      {canEditFields &&
                                        localStorage.getItem("collabType") !==
                                          "CMO" && (
                                          <IconButton
                                            onClick={() =>
                                              handleOpenPlannedBatchDialog(
                                                lot,
                                                component,
                                                index
                                              )
                                            }
                                            size="small"
                                          >
                                            <EditIcon
                                              fontSize="large"
                                              style={{ color: "#ec6535" }}
                                            />
                                          </IconButton>
                                        )}
                                    </>
                                  )}
                                </TableCell>
                              )}
                              {/* Expected Date of Arrival at CMO — editable by BMS Planner
                                  users only; display only for everyone else. Accepts
                                  current/future date only, not mandatory. */}
                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "13%",
                                    minWidth: "150px",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {editingArrivalDateRow ===
                                  `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "4px",
                                      }}
                                    >
                                      <TextField
                                        type="date"
                                        value={expectedArrivalDate}
                                        onChange={handleArrivalDateChange}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        inputProps={{
                                          min: new Date().toISOString().split("T")[0],
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ backgroundColor: "#fff" }}
                                      />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "3px",
                                        }}
                                      >
                                        <span title="save">
                                          <SaveIcon
                                            onClick={() => handleSaveArrivalDate(component)}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                        <span title="clear">
                                          <ClearIcon
                                            onClick={handleCancelArrivalDateEdit}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                      </Box>
                                    </div>
                                  ) : ( 
                                    <>
                                      {component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO &&
                                      component.componentAllocationDetails.expectedDateOfArrivalAtCMO !== "none"
                                        ? dateFormated(
                                            component.componentAllocationDetails.expectedDateOfArrivalAtCMO,
                                            "DD-MMM-YYYY",
                                            ""
                                          ).toUpperCase()
                                        : ""}
                                      {canEditFields && (
                                        <IconButton
                                          onClick={() =>
                                            handleEditArrivalDateClick(component, index)
                                          }
                                          size="small"
                                        >
                                          <EditIcon
                                            fontSize="large"
                                            style={{ color: "#ec6535" }}
                                          />
                                        </IconButton>
                                      )}
                                    </>
                                  )}
                                </TableCell>
                              )}
                              {lotIndex === 0 && (
                                <TableCell
                                  style={{
                                    width: "11%",
                                    minWidth: "100px",
                                    verticalAlign: spanVerticalAlign,
                                  }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {editingCountryRow ===
                                  `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "4px",
                                      }}
                                    >
                                      <TextField
                                        placeholder="Enter Country"
                                        value={countryOfOrigin}
                                        onChange={handleCountryOfOriginChange}
                                        onBlur={handleCountryOfOriginBlur}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1}
                                        InputProps={{
                                          style: {
                                            fontSize: "14px",
                                            lineHeight: "1.4",
                                            // padding: '8px 12px'
                                          },
                                        }}
                                        style={{ backgroundColor: "#fff" }}
                                      />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "3px",
                                        }}
                                      >
                                        <span title="save">
                                          <SaveIcon
                                            onClick={
                                              countryOfOrigin.trim() ||
                                              component
                                                ?.componentAllocationDetails
                                                ?.countryOfOrigin
                                                ? () =>
                                                    handleSaveCountry(component)
                                                : undefined
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                        <span title="clear">
                                          <ClearIcon
                                            onClick={handleCancelCountryEdit}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                      </Box>
                                    </div>
                                  ) : (
                                    <>
                                      {presentFormatedData(
                                        component?.componentAllocationDetails
                                          ?.countryOfOrigin,
                                        ""
                                      )}
                                      {canEditFields &&
                                        localStorage.getItem("collabType") !==
                                          "CMO" && (
                                          <IconButton
                                            onClick={() =>
                                              handleEditCountryClick(
                                                component,
                                                index
                                              )
                                            }
                                            size="small"
                                          >
                                            <EditIcon
                                              fontSize="large"
                                              style={{ color: "#ec6535" }}
                                            />
                                          </IconButton>
                                        )}
                                    </>
                                  )}
                                </TableCell>
                              )}
                              {/* <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgStartDate
                                lotAllocationData={lot}
                                componentDetails = {component}
                                mfgStartDate={lot?.manufacturingStartDate}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell>
                            <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgDispatchDate
                                dispatchDate={lot?.dispatchDate}
                                lotAllocationData={lot}
                                componentDetails = {component}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell>
                            <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgReceiptDate
                                lotReceiptDate={lot?.lotReceiptDate}
                                lotAllocationData={lot}
                                componentDetails = {component}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell> */}
                            </TableRow>
                            );
                          }
                        )
                      ) : component?.inventoryDetails &&
                        component?.inventoryDetails.length < 4 ? (
                        // Case 2: Display inventory data if available (length > 0 and < 4)
                        component?.inventoryDetails.map((val, invIndex) => (
                          <TableRow style={{ width: "100%" }} key={invIndex}>
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "23%", verticalAlign: "top" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                                className={classes.stickyCol1}
                              >
                                <div>
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentCode,
                                    ""
                                  )}
                                  {"/"}
                                </div>
                                <div>
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentName,
                                    ""
                                  )}
                                </div>
                              </TableCell>
                            )}

                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", verticalAlign: "top" }}
                                align="right"
                                rowSpan={component?.inventoryDetails.length}
                                className={classes.stickyCol2}
                              >
                                {component?.componentAllocationDetails
                                  ?.componentQuantity !== undefined &&
                                component?.componentAllocationDetails
                                  ?.componentQuantity !== null
                                  ? Number(
                                      component?.componentAllocationDetails
                                        ?.componentQuantity
                                    ).toFixed(3)
                                  : ""}
                              </TableCell>
                            )}

                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", paddingLeft: "3%", verticalAlign: "top" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                                className={classes.stickyCol3}
                              >
                                {presentFormatedData(
                                  component?.componentAllocationDetails?.uom,
                                  ""
                                )}
                              </TableCell>
                            )}
                            {/* Lot-Specific Data */}
                            <TableCell
                              style={{ width: "11%", whiteSpace: "nowrap" }}
                              align="left"
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                {presentFormatedData(val?.inventoryBatchNumber, "")}
                                {(() => {
                                  const isExpired = val?.inventoryExpiryDate && new Date(val.inventoryExpiryDate) < new Date();
                                  if (isExpired) return (
                                    <FlagIcon style={{ color: "red", fontSize: 16, stroke: "black", strokeWidth: 1.5 }} />
                                  );
                                  if (val?.batchNearExpiry === true) return (
                                    <FlagIcon style={{ color: "yellow", fontSize: 16, stroke: "black", strokeWidth: 1.5 }} />
                                  );
                                  return null;
                                })()}
                              </div>
                            </TableCell>
                            {/* Check if netAvailableQuantity exists before displaying */}
                            <TableCell style={{ width: "11%" }} align="right">
                              {formatNetAvailableQty(val?.netAvailableQuantity)}
                            </TableCell>
                            {/* Date of Manufacturing — display only. */}
                            <TableCell style={{ width: "11%" }} align="left">
                              {val?.dateOfManufacturing
                                ? dateFormated(val.dateOfManufacturing, "DD-MMM-YYYY", "").toUpperCase()
                                : ""}
                            </TableCell>
                            <TableCell
                              style={{ width: "16%", paddingLeft: "3%" }}
                              align="left"
                            >
                              {dateFormated(
                                val?.inventoryExpiryDate,
                                "DD-MMM-YYYY",
                                ""
                              ).toUpperCase()}
                            </TableCell>
                            <TableCell
                              style={{ width: "16%", whiteSpace: "nowrap" }}
                              align="right"
                            >

                              {/* {showPencilButton &&
                                localStorage.collabType !== "CMO" &&
                                featuresAccess?.editPlannedAllocatedQty &&
                                //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                index ===
                                  component?.inventoryDetails.length - 1 && (
                                  <IconButton
                                    onClick={() =>
                                      handleOpenDialog(
                                        component,
                                        component?.componentAllocationDetails
                                          ?.componentCode
                                      )
                                    }
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: "large",
                                        color: "red",
                                      }}
                                    />
                                  </IconButton>
                                )} */}
                              {withLockTooltip(
                                <IconButton
                                  onClick={() =>
                                    handleOpenPlannedQtyDialog(component)
                                  }
                                  disabled={!canEditFields}
                                  className={classes.editIconButton}
                                >
                                  <EditIcon
                                    fontSize="large"
                                    style={{
                                      color: canEditFields ? "#ec6535" : "#bdbdbd",
                                    }}
                                  />
                                </IconButton>
                              )}
                              {/* </div>
                              </div> */}
                            </TableCell>
                            {/* Deplete Instruction — no allocation exists yet on this row,
                                so the column is left blank (no checkbox) when no
                                instruction is held. */}
                            <TableCell align="center" />
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", verticalAlign: "top" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {editingBatchRow ===
                                `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "4px",
                                    }}
                                  >
                                    <TextField
                                      placeholder="164859141N, 164859142N"
                                      value={plannedBatchNumber}
                                      onChange={handlePlannedBatchNumberChange}
                                      onBlur={handlePlannedBatchNumberBlur}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      multiline
                                      minRows={1}
                                      InputProps={{
                                        style: {
                                          fontSize: "14px",
                                          lineHeight: "1.4",
                                          padding: "8px 12px",
                                        },
                                      }}
                                      style={{ backgroundColor: "#fff" }}
                                    />
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px",
                                      }}
                                    >
                                      <span title="save">
                                        <SaveIcon
                                          onClick={
                                            plannedBatchNumber.trim() ||
                                            component
                                              ?.componentAllocationDetails
                                              ?.plannedLotNumbers
                                              ? handleSavePlannedBatch
                                              : undefined
                                          }
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                      <span title="clear">
                                        <ClearIcon
                                          onClick={handleCancelEdit}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                    </Box>
                                  </div>
                                ) : (
                                  <>
                                    {presentFormatedData(
                                      normalizeClearedValue(
                                        component?.componentAllocationDetails
                                          ?.plannedLotNumbers
                                      ),
                                      ""
                                    )}
                                    {canEditFields &&
                                      localStorage.getItem("collabType") !==
                                        "CMO" && (
                                        <IconButton
                                          onClick={() =>
                                            handleOpenPlannedBatchDialog(
                                              val,
                                              component,
                                              index
                                            )
                                          }
                                          size="small"
                                        >
                                          <EditIcon
                                            fontSize="large"
                                            style={{ color: "#ec6535" }}
                                          />
                                        </IconButton>
                                      )}
                                  </>
                                )}
                              </TableCell>
                            )}
                            {/* Expected Date of Arrival at CMO is a material-level field
                                (componentAllocationDetails), so it can be set even before
                                any batch is allocated. */}
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "13%", minWidth: "150px", verticalAlign: "top" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {editingArrivalDateRow ===
                                `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "4px",
                                    }}
                                  >
                                    <TextField
                                      type="date"
                                      value={expectedArrivalDate}
                                      onChange={handleArrivalDateChange}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      inputProps={{
                                        min: new Date().toISOString().split("T")[0],
                                      }}
                                      InputLabelProps={{ shrink: true }}
                                      style={{ backgroundColor: "#fff" }}
                                    />
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px",
                                      }}
                                    >
                                      <span title="save">
                                        <SaveIcon
                                          onClick={() => handleSaveArrivalDate(component)}
                                          style={{ cursor: "pointer", fontSize: "small" }}
                                        />
                                      </span>
                                      <span title="clear">
                                        <ClearIcon
                                          onClick={handleCancelArrivalDateEdit}
                                          style={{ cursor: "pointer", fontSize: "small" }}
                                        />
                                      </span>
                                    </Box>
                                  </div>
                                ) : (
                                  <>
                                    {component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO &&
                                    component.componentAllocationDetails.expectedDateOfArrivalAtCMO !== "none"
                                      ? dateFormated(
                                          component.componentAllocationDetails.expectedDateOfArrivalAtCMO,
                                          "DD-MMM-YYYY",
                                          ""
                                        ).toUpperCase()
                                      : ""}
                                    {canEditFields && (
                                      <IconButton
                                        onClick={() => handleEditArrivalDateClick(component, index)}
                                        size="small"
                                      >
                                        <EditIcon fontSize="large" style={{ color: "#ec6535" }} />
                                      </IconButton>
                                    )}
                                  </>
                                )}
                              </TableCell>
                            )}
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", minWidth: "100px", verticalAlign: "top" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {editingCountryRow ===
                                `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "4px",
                                    }}
                                  >
                                    <TextField
                                      placeholder="Enter Country"
                                      value={countryOfOrigin}
                                      onChange={handleCountryOfOriginChange}
                                      onBlur={handleCountryOfOriginBlur}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      multiline
                                      minRows={1}
                                      InputProps={{
                                        style: {
                                          fontSize: "14px",
                                          lineHeight: "1.4",
                                          // padding: '8px 12px'
                                        },
                                      }}
                                      style={{ backgroundColor: "#fff" }}
                                    />
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px",
                                      }}
                                    >
                                      <span title="save">
                                        <SaveIcon
                                          onClick={
                                            countryOfOrigin.trim() ||
                                            component
                                              ?.componentAllocationDetails
                                              ?.countryOfOrigin
                                              ? () =>
                                                  handleSaveCountry(component)
                                              : undefined
                                          }
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                      <span title="clear">
                                        <ClearIcon
                                          onClick={handleCancelCountryEdit}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                    </Box>
                                  </div>
                                ) : (
                                  <>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.countryOfOrigin,
                                      ""
                                    )}
                                    {canEditFields &&
                                      localStorage.getItem("collabType") !==
                                        "CMO" && (
                                        <IconButton
                                          onClick={() =>
                                            handleEditCountryClick(
                                              component,
                                              index
                                            )
                                          }
                                          size="small"
                                        >
                                          <EditIcon
                                            fontSize="large"
                                            style={{ color: "#ec6535" }}
                                          />
                                        </IconButton>
                                      )}
                                  </>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        ))
                      ) : (
                        // Case 3: Fallback - Display component data with "NA" values when no lot or inventory data available
                        <TableRow style={{ width: "100%" }}>
                          <TableCell style={{ width: "23%" }} align="left">
                            <div>
                              {presentFormatedData(
                                component?.componentAllocationDetails
                                  ?.componentCode,
                                ""
                              )}
                              {"/"}
                            </div>
                            <div>
                              {presentFormatedData(
                                component?.componentAllocationDetails
                                  ?.componentName,
                                ""
                              )}
                            </div>
                          </TableCell>

                          <TableCell style={{ width: "11%" }} align="right">
                            {component?.componentAllocationDetails
                              ?.componentQuantity !== undefined &&
                            component?.componentAllocationDetails
                              ?.componentQuantity !== null
                              ? Number(
                                  component?.componentAllocationDetails
                                    ?.componentQuantity
                                ).toFixed(3)
                              : ""}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", paddingLeft: "3%" }}
                            align="left"
                          >
                            {presentFormatedData(
                              component?.componentAllocationDetails?.uom,
                              ""
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", whiteSpace: "nowrap" }}
                            align="left"
                          >

                          </TableCell>
                          <TableCell style={{ width: "11%" }} align="right">

                          </TableCell>
                          {/* Date of Manufacturing — no batch data available yet. */}
                          <TableCell style={{ width: "11%" }} align="left">

                          </TableCell>
                          <TableCell
                            style={{ width: "16%", paddingLeft: "3%" }}
                            align="left"
                          >

                          </TableCell>

                          <TableCell
                            style={{ width: "16%", whiteSpace: "nowrap" }}
                            align="right"
                          >

                            {/* {showPencilButton &&
                              localStorage.collabType !== "CMO" &&
                              featuresAccess?.editPlannedAllocatedQty && 
                              // (
                                //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                (<IconButton
                                  onClick={() =>
                                    handleOpenDialog(
                                      component,
                                      component?.componentAllocationDetails
                                        ?.componentCode
                                    )
                                  }
                                >
                                  <EditIcon
                                    fontSize="large"
                                    style={{
                                      cursor: "pointer",
                                      color: "#EC6535",
                                      //fontSize: "large",
                                      // color:

                                      //   component.lotNumberAllocationDetails
                                      //     .length > 0
                                      //     ? "#EC6535"
                                      //     : "red",
                                    }}
                                  />
                                </IconButton>
                              )} */}
                            {withLockTooltip(
                              <IconButton
                                onClick={() =>
                                  handleOpenPlannedQtyDialog(component)
                                }
                                disabled={!canEditFields}
                                className={classes.editIconButton}
                              >
                                <EditIcon
                                  fontSize="large"
                                  style={{
                                    color: canEditFields ? "#ec6535" : "#bdbdbd",
                                  }}
                                />
                              </IconButton>
                            )}
                            {/* </div>
                            </div> */}
                          </TableCell>
                          {/* Deplete Instruction — no allocation exists yet, so the column
                              is left blank (no checkbox) in that case. */}
                          <TableCell align="center" />
                          <TableCell style={{ width: "11%" }} align="left">
                            {editingBatchRow ===
                            `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "4px",
                                }}
                              >
                                <TextField
                                  placeholder="164859141N, 164859142N"
                                  value={plannedBatchNumber}
                                  onChange={handlePlannedBatchNumberChange}
                                  onBlur={handlePlannedBatchNumberBlur}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  multiline
                                  minRows={1}
                                  InputProps={{
                                    style: {
                                      fontSize: "14px",
                                      lineHeight: "1.4",
                                      padding: "8px 12px",
                                    },
                                  }}
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "3px",
                                  }}
                                >
                                  <span title="save">
                                    <SaveIcon
                                      onClick={
                                        plannedBatchNumber.trim() ||
                                        component?.componentAllocationDetails
                                          ?.plannedLotNumbers
                                          ? handleSavePlannedBatch
                                          : undefined
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                  <span title="clear">
                                    <ClearIcon
                                      onClick={handleCancelEdit}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                </Box>
                              </div>
                            ) : (
                              <>
                                {presentFormatedData(
                                  normalizeClearedValue(
                                    component?.componentAllocationDetails
                                      ?.plannedLotNumbers
                                  ),
                                  ""
                                )}
                                {canEditFields &&
                                  localStorage.getItem("collabType") !==
                                    "CMO" && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenPlannedBatchDialog(
                                          null,
                                          component,
                                          index
                                        )
                                      }
                                      size="small"
                                    >
                                      <EditIcon
                                        fontSize="large"
                                        style={{ color: "#ec6535" }}
                                      />
                                    </IconButton>
                                  )}
                              </>
                            )}
                          </TableCell>
                          {/* Expected Date of Arrival at CMO is a material-level field
                              (componentAllocationDetails), so it can be set even before
                              any batch is allocated. */}
                          <TableCell
                            style={{ width: "13%", minWidth: "150px" }}
                            align="left"
                          >
                            {editingArrivalDateRow ===
                            `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                              <div style={{ display: "flex", alignItems: "flex-start", gap: "4px" }}>
                                <TextField
                                  type="date"
                                  value={expectedArrivalDate}
                                  onChange={handleArrivalDateChange}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  inputProps={{ min: new Date().toISOString().split("T")[0] }}
                                  InputLabelProps={{ shrink: true }}
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <Box style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                  <span title="save">
                                    <SaveIcon
                                      onClick={() => handleSaveArrivalDate(component)}
                                      style={{ cursor: "pointer", fontSize: "small" }}
                                    />
                                  </span>
                                  <span title="clear">
                                    <ClearIcon
                                      onClick={handleCancelArrivalDateEdit}
                                      style={{ cursor: "pointer", fontSize: "small" }}
                                    />
                                  </span>
                                </Box>
                              </div>
                            ) : (
                              <>
                                {component?.componentAllocationDetails?.expectedDateOfArrivalAtCMO &&
                                component.componentAllocationDetails.expectedDateOfArrivalAtCMO !== "none"
                                  ? dateFormated(
                                      component.componentAllocationDetails.expectedDateOfArrivalAtCMO,
                                      "DD-MMM-YYYY",
                                      ""
                                    ).toUpperCase()
                                  : ""}
                                {canEditFields && (
                                  <IconButton
                                    onClick={() => handleEditArrivalDateClick(component, index)}
                                    size="small"
                                  >
                                    <EditIcon fontSize="large" style={{ color: "#ec6535" }} />
                                  </IconButton>
                                )}
                              </>
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", minWidth: "100px" }}
                            align="left"
                          >
                            {editingCountryRow ===
                            `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "4px",
                                }}
                              >
                                <TextField
                                  placeholder="Enter Country"
                                  value={countryOfOrigin}
                                  onChange={handleCountryOfOriginChange}
                                  onBlur={handleCountryOfOriginBlur}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  multiline
                                  minRows={1}
                                  InputProps={{
                                    style: {
                                      fontSize: "14px",
                                      lineHeight: "1.4",
                                      // padding: '8px 12px'
                                    },
                                  }}
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "3px",
                                  }}
                                >
                                  <span title="save">
                                    <SaveIcon
                                      onClick={
                                        countryOfOrigin.trim() ||
                                        component?.componentAllocationDetails
                                          ?.countryOfOrigin
                                          ? () => handleSaveCountry(component)
                                          : undefined
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                  <span title="clear">
                                    <ClearIcon
                                      onClick={handleCancelCountryEdit}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                </Box>
                              </div>
                            ) : (
                              <>
                                {presentFormatedData(
                                  component?.componentAllocationDetails
                                    ?.countryOfOrigin,
                                  ""
                                )}
                                {canEditFields &&
                                  localStorage.getItem("collabType") !==
                                    "CMO" && (
                                    <IconButton
                                      onClick={() =>
                                        handleEditCountryClick(component, index)
                                      }
                                      size="small"
                                    >
                                      <EditIcon
                                        fontSize="large"
                                        style={{ color: "#ec6535" }}
                                      />
                                    </IconButton>
                                  )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    {/* BCM-234 F9: colSpan bumped 9 -> 10 after adding Storage Location ID column. */}
                    <TableCell colSpan={14} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        </>
      )}

      <div style={{display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
        {/* Approve/Reject Allocation Buttons - Hidden while data is being fetched */}
        {canUserApprove() && !tableLoading && !includeDeleted && !data?.batchDetails?.bomConsumptionAddedIndicator && (
          <Box
            style={{
              marginTop: "1rem",
              marginBottom: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#ec6535",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "8px 24px",
                    fontSize: "0.95rem",
                  }}
                  disableElevation
                  onClick={() => handleApproveRejectAllocation("Approve")}
                >
                  Approve allocation
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "8px 24px",
                    fontSize: "0.95rem",
                    border: "1px solid #ccc",
                  }}
                  disableElevation
                  onClick={() => handleApproveRejectAllocation("Reject")}
                >
                  Reject allocation
                </Button>
              </Grid>
            </Grid>
            
          </Box>
        )}

        {/* BCM-891: per the mock-up, the version number and its history sit on the
            left under the table; the upload and PDF links and the Generate PDF
            button stack on the right. */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "1rem",
            paddingLeft: "1rem",
            // The surrounding column aligns its children right; this row spans it.
            alignSelf: "stretch",
          }}
        >
          <div>
            {/* BCM-891: current version number + version history.
                Rendered only once the API actually returns a versionNumber, so on a
                middleware that does not send it yet this whole block is absent and
                the tab looks exactly as it does today. */}
            {allocationVersionNumber !== undefined &&
              allocationVersionNumber !== null &&
              !tableLoading &&
              !error && (
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "0.75rem",
                  }}
                >
                  <Typography style={{ fontSize: "0.95rem" }}>
                    Current Version Number - {allocationVersionNumber}
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={() => setVersionHistoryOpen(true)}
                    style={{
                      textTransform: "none",
                      borderRadius: "25px",
                      padding: "6px 22px",
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      borderColor: "#333",
                      color: "#1b2541",
                    }}
                  >
                    View Version History
                  </Button>
                </div>
              )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
            {/* Excel Upload Download Link */}
            {excelUploadFile && !tableLoading && !error && (() => {
              const poNumber = data?.scheduleLineDetails?.scheduleAgreementNumber || "";
              const date = new Date(excelUploadFile.lastUpdatedDate).toLocaleString("en-GB", {
                day: "2-digit", month: "short", year: "numeric",
                hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
              }).replace(/ /g, "_").replace(/,/g, "").toUpperCase();
              const ext = excelUploadFile.customFileName?.split(".").pop() || "xlsx";
              const fileName = `PO_${poNumber}_Excel_Upload_${date}.${ext}`;
              return (
                <div style={{ marginTop: "1rem", marginBottom: "0.5rem", display: "flex", justifyContent: "flex-end" }}>
                  <Box style={{ display: "flex", alignItems: "center" }}>
                    <GetAppIcon style={{ fontSize: "20px", color: "#1976d2", marginRight: "4px" }} />
                    <Typography
                      variant="body2"
                      style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline", fontSize: "0.95rem" }}
                      onClick={async () => {
                        try {
                          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadCustomFile`;
                          const res = await axios.post(url, { schrockenCustomFileID: excelUploadFile.schrockenCustomFileID });
                          if (res.data.status) {
                            const byteArray = new Uint8Array(res.data.fileData.data);
                            const blobUrl = window.URL.createObjectURL(new Blob([byteArray], { type: "application/octet-stream" }));
                            const link = document.createElement("a");
                            link.href = blobUrl;
                            link.setAttribute("download", fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(blobUrl);
                          }
                        } catch (err) {
                          console.error("Failed to download Excel file:", err);
                        }
                      }}
                    >
                      {fileName}
                    </Typography>
                  </Box>
                </div>
              );
            })()}

            {/* Download PDF Button - Show when workflow exists (unless rejected), disabled until all approvals complete */}
            {batchAllocationPDFNotificationReqd && !tableLoading && !error && lotAllocationData?.length > 0 && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && (lotAllocationRes?.generateAllocationPDF || (lotAllocationRes?.lastGeneratedPdf && lotAllocationRes?.pdfBase64)) && (
              <div style={{ marginTop: "1rem", marginBottom: "1rem", marginLeft: "1rem", display: "flex", justifyContent: "flex-end" }}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <GetAppIcon style={{ 
                    fontSize: "20px", 
                    color: areAllApprovalsComplete() ? "#1976d2" : "#64bdfe", 
                    marginRight: "4px" 
                  }} />
                  <Typography
                    variant="body2"
                    style={{
                      color: areAllApprovalsComplete() ? "#1976d2" : "#64bdfe",
                      cursor: areAllApprovalsComplete() ? "pointer" : "not-allowed",
                      textDecoration: areAllApprovalsComplete() ? "underline" : "none",
                      fontSize: "0.95rem",
                      opacity: areAllApprovalsComplete() ? 1 : 1,
                    }}
                    onClick={areAllApprovalsComplete() ? handleDownloadPdfFromBase64 : undefined}
                  >
                    {(() => {
                      const allDates = [];
                  
                      // Extract all lastUpdatedDate from lotNumberAllocationDetails
                      plannedComponents()?.forEach(component => {
                        if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
                          component.lotNumberAllocationDetails.forEach(lot => {
                            if (lot?.lastUpdatedDate) {
                              allDates.push(lot.lastUpdatedDate);
                            }
                          });
                        }
                      });
                  
                      // BCM-891: when the last PDF was shared, which may predate the current allocation.
                      const pdfMoment =
                        lotAllocationRes?.lastGeneratedPdf?.generatedAt ||
                        lotAllocationRes?.lastGeneratedPdf?.allocationDate;
                      if (pdfMoment) {
                        allDates.length = 0;
                        allDates.push(pdfMoment);
                      }

                      // Get the latest date
                      const latestDate = allDates.length > 0 
                        ? new Date(allDates.sort().reverse()[0]).toLocaleString('en-GB', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            second: '2-digit', 
                            hour12: false 
                          }).replace(/,/g, '').replace(/ /g, ' ').toUpperCase()
                        : new Date().toLocaleString('en-GB', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            second: '2-digit', 
                            hour12: false 
                          }).replace(/,/g, '').replace(/ /g, ' ').toUpperCase();
                  
                      return `PO_${data?.scheduleLineDetails?.scheduleAgreementNumber || ''}_Batch Allocation_${latestDate}`;
                    })()}
                  </Typography>
                </Box>
              </div>
            )}

            {/* Generate PDF for Existing Allocation Button. Not on a deleted PO: Corda cannot record a share for it.
                BCM-891: the spec says this button "is always displayed on the Batch
                Allocation tab, so that the user can generate a PDF against the
                current version whenever required", and "remains available even when
                a PDF has already been generated for the current version". It used
                to disappear as soon as a PDF existed, which left no way to generate
                one against a newer version. The generated-PDF link below is
                unchanged and now sits alongside it, as the spec's Delivered/Deleted
                page describes. */}
            {(featuresAccess?.generatePDF || featuresAccess?.editPlannedAllocatedQty) && (localStorage?.collabType !== "CMO") && !(includeDeleted && (poMarkedForDelete || lotAllocationRes?.markedForDelete)) && batchAllocationPDFNotificationReqd && !tableLoading && !error && lotAllocationData?.length > 0 && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && (
              <div style={{ marginTop: "1rem", marginBottom: "1rem", marginLeft: "1rem", display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  onClick={handleContinueToGeneratePdf}
                  disabled={sharingWithoutApproval}
                  style={{
                    textTransform: "none",
                    borderRadius: "25px",
                    padding: "6px 16px",
                    fontSize: "0.875rem",
                    borderColor: "#666",
                    color: "#333",
                  }}
                >
                  {sharingWithoutApproval && (
                    <CircularProgress size={16} style={{ marginRight: "8px", color: "#ec6535" }} />
                  )}
                  Generate PDF for Existing Allocation
                </Button>
              </div>
            )}
          </div>
        </div>

        {/* BCM-891: "View documents" from the tooltip — the same batch detail view the PO dashboard opens. */}
        {batchDocumentsOpen && (
          <Dialog fullScreen open={batchDocumentsOpen} onClose={() => setBatchDocumentsOpen(false)}>
            <QuickView
              schrockenDeliveryScheduleBatchID={data?.batchDetails?.schrockenDeliveryScheduleBatchID}
              schrockenDeliveryScheduleID={data?.batchDetails?.schrockenDeliveryScheduleID}
              targetQuantity={data?.scheduleLineDetails?.targetQuantity}
              poQuantity={data?.scheduleLineDetails?.targetQuantity}
              setDialogOpen={() => setBatchDocumentsOpen(false)}
              qualityApprovalFlowFlag={data?.batchDetails?.qualityApprovalFlowFlag}
              isApprovedButton={false}
              selectedBatch={data}
              poRowData={data}
              isFromPoDashboard={true}
              cmoBatchNumber={data?.batchDetails?.cmoBatchNumber}
            />
          </Dialog>
        )}

        <VersionHistoryDialog
          open={versionHistoryOpen}
          onClose={() => setVersionHistoryOpen(false)}
          schrockenSLID={data?.scheduleLineDetails?.schrockenSLID}
          onDownloadPdf={handleDownloadVersionPdf}
        />

      </div>

      {/* Approval Workflow Note */}
          {batchAllocationPDFNotificationReqd && approvalNote && localStorage.getItem("collabType") === "Pharma Co" && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && (
            <Box
              style={{
                marginTop: "1rem",
                padding: "12px 16px",
                // backgroundColor: "#fff3cd",
                border: "1px solid #000",
                borderRadius: "4px",
                display: "flex",
                alignItems: "flex-start",
                fontSize: "0.875rem",
              }}
            >
              <Typography
                variant="body2"
                style={{
                  // color: "#856404",
                  fontSize: "0.875rem",
                  lineHeight: "1.5",
                  fontWeight: 500,
                }}
              >
                <span style={{fontWeight: 500}}>Note - </span>{approvalNote}
              </Typography>
            </Box>
          )}

      {/* Over-allocation Note - Only for CMO
      {localStorage.collabType === "CMO" && overAllocatedComponents.length > 0 && (
        <div style={{
          marginTop: "1rem",
          padding: "0.75rem 1rem",
          backgroundColor: "#FFF0F0",
          border: "1px solid #FF0000",
          borderRadius: "4px",
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          maxWidth: '592px',
          marginLeft: 'auto',
        }}>
          <WarningIcon style={{ color: "#FF0000", fontSize: "1.25rem" }} />
          <Typography variant="body2" style={{ color: "#f00", lineHeight: "1.5" }}>
            Material Code / Description was changed in BMS SAP. PO is not in the limit of allowing<br/> batch allocation change. Please change the PO delivery date to enable batch allocation.
          </Typography>
        </div>
      )} */}

      {lotAllocationRes?.consumptionDataReqdForIBDGRN &&
        typeof lotAllocationRes?.allocationOwnedBySponsor === "boolean" && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#fff",
              border: "1px solid #0b0b0bff",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              {lotAllocationRes?.allocationOwnedBySponsor
                ? `Note - Allocation is owned by ${
                    data?.scheduleLineDetails?.sponsorName
                      ? data.scheduleLineDetails.sponsorName
                      : "BMS"
                  }`
                : `Note - Allocation is not owned by ${
                    data?.scheduleLineDetails?.sponsorName
                      ? data.scheduleLineDetails.sponsorName
                      : "BMS"
                  }`}
            </Typography>
          </div>
        )}

      {typeof lotAllocationRes?.consumptionDataReqdForIBDGRN === "boolean" &&
        lotAllocationRes?.consumptionDataReqdForIBDGRN === false && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#fff",
              border: "1px solid #0b0b0bff",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              {!lotAllocationRes?.consumptionDataReqdForIBDGRN &&
                `Note - Consumption Information is not required for IBD/GRN`}
            </Typography>
          </div>
        )}
      {/* BOM Change Warning Message */}
      {data?.scheduleLineDetails?.editPlannedAllocation === false && 
       data?.scheduleLineDetails?.changeInBOM === true && data?.batchDetails?.bomConsumptionAddedIndicator === false && (
        <div style={{
          marginTop: "1rem",
          padding: "0.75rem 1rem",
          backgroundColor: "#FFF0F0",
          border: "1px solid #FF0000",
          borderRadius: "4px",
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          maxWidth: '592px',
          marginLeft: 'auto',
        }}>
          <WarningIcon style={{ color: "#FF0000", fontSize: "1.25rem" }} />
          <Typography variant="body2" style={{ color: "#f00", lineHeight: "1.5" }}>
            Material Code / Description was changed in BMS SAP. PO is not in the limit of allowing<br/> batch allocation change.
          </Typography>
        </div>
      )}

      {/* The deplete instruction note previously shown below the batch allocation
          table is withdrawn — the deplete instruction is now conveyed through the
          Planned Allocated Qty. and Deplete Instruction columns instead. */}

      {/* Inventory Dialog */}
      <Dialog
        open={openDialog}
        // onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
      >
        <EditPlannedAllocatedQuantityDialog
          lotData={selectedLotData}
          lotAllocationRes={lotAllocationRes}
          lotAllocationData={lotAllocationData}
          rmPmCode={rmPmCode}
          onClose={handleCloseDialog}
          poData={data}
          schrockenSLID={data?.scheduleLineDetails?.schrockenSLID}
          vendorMosymphonyID={data?.scheduleLineDetails?.vendorMosymphonyID}
          handleClose={handleLotAllocationStatus}
        />
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} maxWidth="md" fullWidth>
        <DeleteLotAllocationDialog
          open={openDeleteDialog}
          onClose={handleCloseDeleteDialog}
          lotData={selectedLotForDelete}
          componentData={selectedComponentForDelete}
          poData={data}
          schrockenSLID={data?.scheduleLineDetails?.schrockenSLID}
          vendorMosymphonyID={data?.scheduleLineDetails?.vendorMosymphonyID}
          lotAllocationRes={lotAllocationRes}
          onSuccess={handleDeleteStatus}
          shouldTrackDeletion={hasEnabledApprovalFlag()}
          poNumber={data?.scheduleLineDetails?.scheduleAgreementNumber}
        />
      </Dialog>

      {/* <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth='sm'
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon className={classes.avatar} />
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "1.4rem",
            }}
          >
            Component Allocation updated successfully
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant='contained'
              color='primary'
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                handleRefresh();
                setSuccessDialogBox({
                  openDialogBox: false,
                  // dialogBoxType: "",
                });
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog> */}

      {/* Edit Success Dialog - Show PDF flow only when both conditions are met */}
      <Dialog open={editSuccessDialogOpen && showPdfGenerationFlow && batchAllocationPDFNotificationReqd} fullWidth maxWidth="lg" PaperProps={{ style: { maxWidth: lotAllocationData?.length > 1 ? "840px" : "580px" } }}>
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Success Icon */}
            <Grid item style={{paddingBottom: 0}}>
              <CheckCircleIcon style={{ fontSize: "4rem", color: "#28a745" }} />
            </Grid>
            
            {/* Success Message */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                Batch Allocation updated successfully
              </Typography>
            </Grid>

            {/* Instruction Text - Only show for multiple materials/components */}
            {lotAllocationData?.length > 1 && (
              <Grid item style={{ width: "100%"}}>
                <Typography variant="body1" style={{ textAlign: "center", fontSize: "18px", color: "#333" }}>
                  There are multiple materials/components in this PO. Please<br/> confirm if you want to complete/change allocation for the other<br/> materials/components and then generate PDF notification.
                </Typography>
              </Grid>
            )}

            {/* Action Buttons */}
            <Grid item container spacing={4} justifyContent="center" style={{ marginTop: lotAllocationData?.length > 1 ? "0.2rem" : null }}>
              {lotAllocationData?.length > 1 ? (
                <>
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={handleContinueToGeneratePdf}
                      style={{
                        borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                        borderColor: "#666",
                        fontWeight: 600,
                      }}
                    >
                      Continue without further allocations
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      onClick={handleAllocateRemainingMaterials}
                      style={{
                        borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                        backgroundColor: "#ec6535",
                        color: "#fff"
                      }}
                    >
                      Allocate batch for remaining materials/components
                    </Button>
                  </Grid>
                </>
              ) : (
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={handleContinueToGeneratePdf}
                    style={{
                      borderRadius: "25px",
                      textTransform: "none",
                      padding: "8px 15px",
                      fontSize: "14px",
                      backgroundColor: "#ec6535",
                      color: "#fff"
                    }}
                  >
                    Continue to generate PDF
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      
      {/* Page loader while the table refreshes ahead of the Generate PDF popup */}
      <Backdrop open={pdfFlowPageLoading} style={{ zIndex: 1500, color: "#fff" }}>
        <CircularProgress style={{ color: "#ec6535" }} />
      </Backdrop>

      {/* Simple Success Dialog - for non-PDF updates or when PDF flow is disabled */}
      <Dialog open={editSuccessDialogOpen && (!showPdfGenerationFlow || !batchAllocationPDFNotificationReqd)} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={() => {
            setEditSuccessDialogOpen(false);
            setEditSuccessMessage("");
            setShowPdfGenerationFlow(true); // Reset to default
            handleRefreshLotAllocation();
          }}
          title={editSuccessMessage || "Component Allocation updated successfully"}
        />
      </Dialog>

      {/* PDF Generation Dialog */}
      <Dialog open={pdfGenerationDialogOpen} fullWidth maxWidth="sm">
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Close Button */}
            {/* <Grid item style={{ width: "100%", display: "flex", justifyContent: "flex-end", padding: 0 }}>
              <Box style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setPdfGenerationDialogOpen(false)}>
                <Typography variant="body2" style={{ marginRight: "8px", fontWeight: 500 }}>Cancel</Typography>
                <CloseIcon style={{ color: "#FF0000" }} />
              </Box>
            </Grid> */}
            {/* Title */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                Generating PDF notification for Allocation
              </Typography>
            </Grid>

            {/* Checkboxes Section */}
            <Grid item style={{ width: "100%", marginTop: "1rem" }}>
              {/* BCM-891: the CMO configuration decides which fields are captured,
                  so the user no longer picks them. Shown only for a middleware
                  that does not send the configuration flags yet. */}
              {!pdfConfigured && (
                <Typography variant="body2" style={{ textAlign: "left", marginBottom: "12px", fontWeight: 600 }}>
                  Select Information Required in Batch Allocation PDF
                </Typography>
              )}
              {/* BCM-891: the three pick-your-fields checkboxes go away once the
                  CMO configuration decides. Shown only without the flags. */}
              {!pdfConfigured && (
                <>
              
              {/* Validation Error Message */}
              {pdfFieldValidationError && (
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#FFF0F0",
                    border: "1px solid #FF0000",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      color: "#FF0000",
                      fontSize: "0.875rem",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    {pdfFieldValidationError}
                  </Typography>
                </div>
              )}
              
              <Box style={{ display: "flex", gap: "24px", marginBottom: "1.5rem" }}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeDocumentId}
                    onChange={(e) => {
                      setIncludeDocumentId(e.target.checked);
                      if (!e.target.checked) {
                        setDocumentId("");
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    Document ID
                  </Typography>
                </Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeBomCode}
                    onChange={(e) => {
                      setIncludeBomCode(e.target.checked);
                      if (!e.target.checked) {
                        setBomCode("");
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    BoM Code
                  </Typography>
                </Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeArtworkCode}
                    onChange={(e) => {
                      setIncludeArtworkCode(e.target.checked);
                      if (!e.target.checked) {
                        setArtworkCode("");
        setArtworkCodes([""]);
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    Artwork Code
                  </Typography>
                </Box>
              </Box>
                </>
              )}
            </Grid>

            {/* Document ID Input.
                BCM-891: "Fields configured as No are not displayed." Shown
                unconditionally only while the middleware sends no
                configuration, where the checkbox group still drives it. */}
            {(!pdfConfigured || includeDocumentId) && (
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeDocumentId ? "inherit" : "#9e9e9e" }}>
                Document ID {includeDocumentId && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={documentId}
                onChange={(e) => {
                  setDocumentId(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setDocumentId(e.target.value.trim());
                }}
                size="small"
                disabled={!includeDocumentId}
              />
            </Grid>
            )}

            {/* BCM-891: BoM Code is removed from the popup and from the PDF.
                Rendered only while the middleware does not send the CMO
                configuration flags. */}
            {!pdfConfigured && (
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeBomCode ? "inherit" : "#9e9e9e" }}>
                BoM Code {includeBomCode && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={bomCode}
                onChange={(e) => {
                  setBomCode(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setBomCode(e.target.value.trim());
                }}
                size="small"
                disabled={!includeBomCode}
              />
            </Grid>
            )}

            {/* Artwork Code Input.
                BCM-891: hidden when the product type does not require it, per
                "Fields configured as No are not displayed". */}
            {(!pdfConfigured || includeArtworkCode) && (
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeArtworkCode ? "inherit" : "#9e9e9e" }}>
                Artwork Code {includeArtworkCode && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              {pdfConfigured ? (
                <>
                  {artworkCodes.map((code, index) => (
                    <Box key={index} display="flex" alignItems="center" style={{ marginBottom: 8 }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Enter value here"
                        value={code}
                        onChange={(e) => {
                          setArtworkCodeAt(index, e.target.value);
                          if (pdfFieldValidationError) setPdfFieldValidationError("");
                        }}
                        onBlur={(e) => setArtworkCodeAt(index, e.target.value.trim())}
                        size="small"
                        disabled={!includeArtworkCode}
                      />
                      {/* Fixed-width action slot on every row so all the
                          textboxes end at the same edge, whichever icons show. */}
                      <Box display="flex" alignItems="center" flexShrink={0} style={{ width: 64, marginLeft: 4 }}>
                      {/* The first box has no delete: at least one code is
                          mandatory when Artwork Code Required is Yes. */}
                      {index > 0 && (
                        <IconButton
                          size="small"
                          onClick={() => removeArtworkCode(index)}
                          disabled={!includeArtworkCode}
                          title="Remove this artwork code"
                        >
                          <DeleteIcon fontSize="small" style={{ color: "#d32f2f" }} />
                        </IconButton>
                      )}
                      {/* Plus sits on the first row only, per the design, and
                          stays disabled until the last row has a value so an
                          empty box is never added below another empty one. */}
                      {index === 0 && (
                        <IconButton
                          size="small"
                          onClick={addArtworkCode}
                          disabled={
                            !includeArtworkCode ||
                            String(artworkCodes[artworkCodes.length - 1] || "").trim() === ""
                          }
                          title="Add another artwork code"
                        >
                          <AddCircleOutlineIcon style={{ color: "#333" }} />
                        </IconButton>
                      )}
                      </Box>
                    </Box>
                  ))}
                </>
              ) : (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={artworkCode}
                onChange={(e) => {
                  setArtworkCode(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setArtworkCode(e.target.value.trim());
                }}
                size="small"
                multiline
                minRows={2}
                disabled={!includeArtworkCode}
              />
              )}
            </Grid>
            )}

            {/* Instructions Text.
                BCM-891: the spec removes the line asking the user to choose
                whether approvals are required — the product type decides that.
                Kept only while the middleware sends no configuration. */}
            {!pdfConfigured && (
            <Grid item style={{ width: "100%", marginTop: "0.5rem" }}>
              <Typography variant="body2" style={{ textAlign: "center", fontSize: "0.95rem", lineHeight: "1.6"}}>
                Select if you need approvals or not before sharing the PDF with CMO
              </Typography>
            </Grid>
            )}

            {/* No-input product type: the share starts as soon as the popup opens,
                so only a loader is shown. If it fails the button comes back to retry. */}
            {pdfNeedsNoInput && sharingWithoutApproval ? (
            <Grid item style={{ marginTop: "0.5rem" }}>
              <CircularProgress style={{ color: "#ec6535" }} />
              <Typography variant="body2" style={{ marginTop: "0.75rem" }}>
                Generating PDF...
              </Typography>
            </Grid>
            ) : (
            /* Action Buttons */
            <Grid item container spacing={2} justifyContent="center" style={{ marginTop: "0.5rem" }}>
              {/* BCM-891: not offered when the product type requires approval —
                  such a PDF cannot reach the CMO without the workflow. Its label
                  becomes "Share PDF with CMO" once the configuration arrives. */}
              {!cfgApprovalReqd && (
              <Grid item>
                <Button
                  variant={pdfConfigured ? "contained" : "outlined"}
                  onClick={handleShareWithoutApprovals}
                  disabled={sharingWithoutApproval}
                  style={{
                    borderRadius: "25px",
                    textTransform: "none",
                    padding: "8px 20px",
                    fontSize: "14px",
                    // BCM-891: the design shows "Share PDF with CMO" as a solid
                    // orange button; the legacy outlined style stays for
                    // "Share without approvals".
                    ...(pdfConfigured
                      ? { backgroundColor: "#ec6535", color: "#fff" }
                      : { borderColor: "#666", color: "#666" })
                  }}
                >
                  {sharingWithoutApproval ? (
                    <>
                      <CircularProgress size={20} style={{ marginRight: "8px", color: pdfConfigured ? "#fff" : undefined }} />
                      Sharing...
                    </>
                  ) : (
                    // BCM-891: the spec's single button for a product type
                    // that needs no approval.
                    pdfConfigured ? "Share PDF with CMO" : "Share without approvals"
                  )}
                </Button>
              </Grid>
              )}
              {/* BCM-891: the only button when approval is required. */}
              {(!pdfConfigured || cfgApprovalReqd) && (
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleShareAfterApprovals}
                  disabled={sharingWithoutApproval}
                  style={{
                    borderRadius: "25px",
                    textTransform: "none",
                    padding: "8px 20px",
                    fontSize: "14px",
                    backgroundColor: "#ec6535",
                    color: "#fff"
                  }}
                >
                  {/* BCM-891: the spec names this button "Share with Approvals". */}
                  {pdfConfigured ? "Share with Approvals" : "Share after approvals"}
                </Button>
              </Grid>
              )}
            </Grid>
            )}
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Delete Success Dialog */}
      <Dialog open={deleteSuccessDialogOpen} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={() => {
            setDeleteSuccessDialogOpen(false);
            handleRefreshLotAllocation();
          }}
          title="Batch Allocation updated Successfully"
        />
      </Dialog>

      {/* Share Success Dialog */}
      <Dialog open={shareSuccessDialogOpen} fullWidth maxWidth="sm">
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Success Icon */}
            <Grid item>
              <CheckCircleIcon style={{ fontSize: "4rem", color: "#28a745" }} />
            </Grid>
            
            {/* Success Message */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                Allocation change PDF shared successfully
              </Typography>
            </Grid>

            {/* OK Button */}
            <Grid item style={{ marginTop: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => {
                  setShareSuccessDialogOpen(false);
                  handleRefreshLotAllocation();
                }}
                style={{
                  borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                  backgroundColor: "#ec6535",
                  color: "#fff"
                }}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Workflow Dialog workflowDialogOpen */}
      <Dialog open={workflowDialogOpen} fullWidth maxWidth="lg">
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container>
            {/* Header */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                Define review/approval workflow
              </Typography>
              <Box style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setWorkflowDialogOpen(false)}>
                <Typography variant="body2" style={{ marginRight: "8px", fontWeight: 500 }}>Close</Typography>
                <CloseIcon style={{ color: "#FF0000" }} />
              </Box>
            </Grid>

            {/* Workflow details label */}
            <Grid item xs={12} style={{ marginBottom: "1rem" }}>
              <Typography variant="body1" style={{ fontWeight: 600 }}>
                Workflow details <span style={{ color: "#FF0000" }}>*</span>
              </Typography>
            </Grid>

            {/* Validation Error Message */}
            {workflowValidationError && (
              <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#FFF0F0",
                    border: "1px solid #FF0000",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      color: "#FF0000",
                      fontSize: "0.875rem",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    {workflowValidationError}
                  </Typography>
                </div>
              </Grid>
            )}

            {/* Table */}
            <Grid item xs={12} style={{ marginBottom: "1.5rem" }}>
              <TableContainer component={Paper} style={{ border: "1px solid #e0e0e0" }}>
                <Table>
                  <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell style={{ fontWeight: 600, color: "#00000061" }}>Requirement</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Approver Org</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Assigned team member</TableCell>
                      <TableCell style={{ fontWeight: 600, color: "#00000061" }}>Signature</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Change order</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {approvers.map((approver, index) => (
                      <TableRow 
                        key={approver.id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragEnd={handleDragEnd}
                        style={{
                          cursor: "move",
                          backgroundColor: draggedItem === index ? "#f0f0f0" : "transparent"
                        }}
                      >
                        <TableCell>
                          <TextField
                            select
                            value={approver.requirement}
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled
                            SelectProps={{
                              native: true,
                            }}
                          >
                            <option value="Approval">Approval</option>
                          </TextField>
                        </TableCell>
                        <TableCell>{approver.approverOrg}</TableCell>
                        <TableCell>
                          <Autocomplete
                            value={teamMembers.find(member => member.email === approver.assignedMember) || null}
                            onChange={(event, newValue) => {
                              handleUpdateAssignedMember(approver.id, newValue?.email || "");
                            }}
                            options={teamMembers.filter(member => 
                              member.email !== tokenData.email_address &&
                              !approvers.some(app => app.id !== approver.id && app.assignedMember === member.email)
                            )}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                variant="outlined"
                                placeholder="Select from this list"
                                className={classes.blackBorderFieldset}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            select
                            value={approver.signature}
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled
                            SelectProps={{
                              native: true,
                            }}
                          >
                            <option value="Electronic">Electronic</option>
                          </TextField>
                        </TableCell>
                        <TableCell>
                          {/* <DragIndicatorIcon style={{ fontSize: "24px", color: "#999", cursor: "move" }} /> */}
                          <i className="fa fa-arrows-alt" style={{color: "#00000061"}} />
                        </TableCell>
                        <TableCell>
                          {index === 0 ? null : (
                            <IconButton size="small" onClick={() => handleRemoveApprover(approver.id)}>
                              <DeleteIcon style={{ fontSize: "20px", color: "#FF0000" }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Add approver button */}
            <Grid item xs={12} style={{ marginBottom: "2rem" }}>
              <Button
                variant="outlined"
                onClick={handleAddApprover}
                style={{
                  borderRadius: "40px",
                  textTransform: "none",
                  padding: "8px 20px",
                  fontSize: "0.95rem",
                  borderColor: "#000",
                  color: "#000"
                }}
              >
                <Box style={{ 
                  border: "2px solid #000", 
                  borderRadius: "50%", 
                  width: "20px", 
                  height: "20px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  fontSize: "16px",
                  marginRight: "8px"
                }}>+</Box>
                Add approver
              </Button>
            </Grid>

            {/* Save button */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={handleSaveWorkflow}
                disabled={savingWorkflow}
                endIcon={savingWorkflow ? <CircularProgress size={20} style={{ color: "white" }} /> : <span style={{ fontSize: "18px" }}>›</span>}
                style={{
                  borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                  backgroundColor: "#ec6535",
                  color: "#fff",
                  opacity: savingWorkflow ? 0.8 : 1
                }}
              >
                {savingWorkflow ? "Saving..." : "Save and send for review/approval"}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px", }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Legend for Material Near Expiry / Expired Flag */}
      {(() => {
        const hasNearExpiry = lotAllocationData?.some(component =>
          component?.inventoryDetails?.some(inv => inv?.batchNearExpiry === true)
        );
        const hasExpired = lotAllocationData?.some(component =>
          component?.inventoryDetails?.some(inv =>
            inv?.inventoryExpiryDate && new Date(inv.inventoryExpiryDate) < new Date()
          )
        );
        if (!hasNearExpiry && !hasExpired) return null;
        return (
          <div style={{
            marginTop: "1rem", padding: "0.5rem", backgroundColor: "#f9f9f9",
            border: "1px solid #e0e0e0", borderRadius: "4px",
            display: "flex", alignItems: "center", gap: "16px", fontSize: "0.875rem"
          }}>
            <Typography variant="caption" style={{ fontSize: "0.875rem" }}>Legend:</Typography>
            {hasNearExpiry && (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <FlagIcon style={{ color: "yellow", fontSize: 20, stroke: "black", strokeWidth: 1.5 }} />
                <Typography variant="caption" style={{ fontSize: "0.875rem" }}>Material near expiry</Typography>
              </div>
            )}
            {hasExpired && (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <FlagIcon style={{ color: "red", fontSize: 20, stroke: "black", strokeWidth: 1.5 }} />
                <Typography variant="caption" style={{ fontSize: "0.875rem" }}>Batch expired</Typography>
              </div>
            )}
          </div>
        );
      })()}
      {/* Info Dialog for Planned Material Batch Number */}
      <Dialog
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent style={{ padding: "24px" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setInfoDialogOpen(false)}
            >
              Close <CloseIcon fontSize="large" style={{ color: "#FF0000" }} />
            </Typography>
          </Grid>
          <Grid
            container
            direction="column"
            alignItems="center"
            style={{ marginTop: "16px" }}
          >
            <Typography
              variant="h6"
              style={{ fontWeight: 600, marginBottom: "20px" }}
            >
              Planned Material Batch Number
            </Typography>
            <Typography
              variant="body2"
              style={{ textAlign: "center", lineHeight: "1.6" }}
            >
              Please use this field is to enter Material Batch Number
              <br /> that is not yet present in the inventory. In case of
              multiple
              <br /> Batch Number entry, use comma to separate the values.
            </Typography>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Electronic Signature Validation Dialog */}
      <BatchAllocationElectronicSignature
        open={electronicSignatureDialog.open}
        onClose={handleCloseElectronicSignature}
        allocationDetails={{
          decision: electronicSignatureDialog.decision,
          poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber || "",
        }}
        handleESignatureSuccess={handleElectronicSignatureSuccess}
      />

      {/* Approve/Reject Success Dialog */}
      <Dialog
        open={approveRejectSuccess.open}
        onClose={() => {}}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent style={{ padding: "2rem", textAlign: "center" }}>
          <CheckCircleIcon style={{ fontSize: 60, color: "#399438", marginBottom: "1rem" }} />
          <Typography variant="h6" style={{ fontWeight: 600, marginBottom: "1rem" }}>
            {approveRejectSuccess.type === "Approve" ? "Allocation Approved Successfully" : "Allocation Rejected Successfully"}
          </Typography>
          <Typography variant="body2" style={{ marginBottom: "1.5rem" }}>
            {approveRejectSuccess.type === "Approve" 
              ? "The component allocation has been approved."
              : "The component allocation has been rejected."}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setApproveRejectSuccess({ open: false, type: "" });
              // Trigger data fetch after user closes success dialog
              setIsProcessingApproval(false);
            }}
            style={{ 
              borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
            }}
          >
            OK
          </Button>
        </DialogContent>
      </Dialog>


    </React.Fragment>
  );
};

export default LotAllocationTable;
